/* ARCHER LASER — customizer tweaks.
   Removals and adjustments to the Product Customizer's interface, applied at
   runtime. The customizer's own file is never edited, so it stays exactly as
   its author wrote it; everything asked for after the fact lives here.

   The tool re-renders as people work, so every tweak is written to be safe to
   run again and again, and a watcher re-applies them after each render.

   Used by:
     archer-customizer-plugin.js   (the shop overlay)
     preview-customizer.html       (the tool on its own)                     */
(function () {
  'use strict';

  /* Removed at the shop's request: the Product size picker (1 / 1.5 / 2 / 3 in)
     in the Settings menu. Engraving size is set by the piece, not by the
     visitor, so the choice only caused confusion. The heading goes with it. */
  function hideProductSize(d) {
    var spans = d.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      var head = spans[i];
      if ((head.textContent || '').trim() !== 'Product size') continue;
      var grid = head.nextElementSibling;
      head.style.display = 'none';
      head.setAttribute('data-acp-removed', 'product-size');
      /* the options sit in the grid right after the heading */
      if (grid && grid.querySelector('button')) {
        grid.style.display = 'none';
        grid.setAttribute('data-acp-removed', 'product-size');
      }
    }
  }

  /* Removed with it: the two measuring rules either side of the piece and the
     size they report ("2 in"). With the picker gone there is nothing to change,
     so the readout only raises a question the visitor cannot act on. Each rule
     is a line / label / line group, so the label's container goes. */
  var SIZE = /^\d+(\.\d+)?\s*in$/i;
  function isHairline(el) {
    if (!el || (el.textContent || '').trim()) return false;
    var r = el.getBoundingClientRect();
    return (r.width <= 2 && r.height > 6) || (r.height <= 2 && r.width > 6);
  }
  function hideRulers(d) {
    var spans = d.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      var lbl = spans[i];
      if (!SIZE.test((lbl.textContent || '').trim())) continue;
      /* the rule is the nearest ancestor holding both the label and a hairline;
         the across-rule has one either side, the down-rule just one */
      var group = lbl.parentElement, hops = 0;
      while (group && hops++ < 3) {
        var kids = group.children, lines = 0;
        for (var k = 0; k < kids.length; k++) if (isHairline(kids[k])) lines++;
        if (lines) {
          group.style.display = 'none';
          group.setAttribute('data-acp-removed', 'size-rule');
          break;
        }
        group = group.parentElement;
      }
    }
  }

  /* Asked for: a text box (and an uploaded image) on the piece is exactly the
     size of what is in it, so the box the visitor sees and drags is the text
     itself — nothing can hang past the dashed safe area unseen. Every element
     on the piece is an absolutely placed, draggable wrapper (cursor: move);
     text wrappers hold a pre-wrap div, uploads hold an img. A stylesheet, not
     a per-render fix, so it holds through every re-render without a flicker. */
  var FIT_CSS = [
    '[style*="cursor: move"]:has(> [style*="white-space: pre-wrap"]){',
      'width:max-content !important;max-width:100%;}',
    '[style*="cursor: move"] > [style*="white-space: pre-wrap"]{padding:0 !important;}',
    '[style*="cursor: move"]:has(> textarea){width:max-content !important;max-width:100%;}',
    '[style*="cursor: move"] > textarea{resize:none !important;overflow:hidden !important;box-sizing:content-box;white-space:pre;padding:0 !important;}',
    '[style*="cursor: move"]:has(> img){height:auto !important;}',
    '[style*="cursor: move"] > img{display:block;width:100%;height:auto !important;}',
    /* asked for: a bigger Duplicate glyph in the element toolbar */
    'button[title^="Duplicate"]{font-size:24px !important;line-height:1 !important;}',
    /* group / ungroup: chosen pieces while picking, and members of a group */
    '[data-acp-sel]{outline:2px dashed rgb(34, 160, 63) !important;outline-offset:2px;}',
    '[data-acp-group]{outline:1.5px dashed rgb(180, 84, 31);outline-offset:4px;}',
    /* asked for: the B / I toggles read as disabled when off (grey text) — off\n       now shows in ink, on keeps the tool\u2019s own filled look */
    'button[style*="color: rgb(156, 163, 175)"][style*="flex: 0 0 40px"]{color:rgb(17, 24, 39) !important;}',
    /* asked for: Undo / Redo sit beside Delete in the same quiet icon + label
       style instead of two outlined pills */
    'button[title^="Undo"],button[title^="Redo"]{border:0 !important;background:transparent !important;',
      'padding:0 6px !important;height:30px !important;gap:6px !important;border-radius:6px !important;}',
    'button[title^="Undo"] > span,button[title^="Redo"] > span{font-size:18px !important;}',
    /* asked for: the whole toolbar on one line — tighter gaps so Undo / Redo
       fit beside Delete instead of wrapping underneath */
    '[style*="flex-wrap: wrap"][style*="border-radius: 16px"]:has(button[title^="Duplicate"]){',
      'flex-wrap:nowrap !important;gap:5px !important;padding:8px 10px !important;}',
    '[data-acp-btn],button[title="Delete"],button[title^="Undo"],button[title^="Redo"]{padding:0 4px !important;font-size:13px !important;}',
    /* the two toolbars joined into one card: image row on top, text row under */
    '[data-acp-bar="image"]{border-radius:16px 16px 0 0 !important;padding-bottom:6px !important;}',
    '[data-acp-bar="text"]{border-radius:0 0 16px 16px !important;margin-top:-12px !important;padding-top:6px !important;',
      'clip-path:inset(0 -40px -40px -40px);}',
    '[data-acp-bar="image"] + [data-acp-bar="text"]{border-top:1px solid rgb(243, 244, 246);}',
    /* which product photo is showing: the thumbnails mark it, not the side */
    'button[data-acp-face="on"]{border-color:rgb(30, 42, 138) !important;}',
    'button[data-acp-face="on"][data-acp-current="on"]{box-shadow:0 0 0 2px rgba(30, 42, 138, .25);}',
    'button[data-acp-face="off"]{border-color:rgb(229, 231, 235) !important;}',
    /* removed: the floating mini toolbar over a selected text box (T, colour
       dots, font) — everything on it is already in the main toolbar */
    '[style*="cursor: move"] > [style*="bottom: calc(100% + 18px)"]{display:none !important;}'
  ].join('\n');
  /* Removed at the shop's request: the three vertical-placement buttons in
     the text toolbar (Move to top / Centre vertically / Move to bottom), and
     the box-width Smaller / Larger pair — boxes fit their content now, so
     the pair did nothing visible. */
  var REMOVE_TITLES = ['Move to top of design', 'Centre vertically', 'Move to bottom of design', 'Smaller', 'Larger', 'Alignment', 'Canvas settings', 'Keyboard shortcuts', '\u25A2 Upload from your phone', 'Upload from your phone'];
  /* also removed: the unlabelled round button in the corner of the design
     area (52px, blue ring, rectangle glyph) — matched by its look */
  /* image toolbar: Change image and the Erase tool go too (matched by label,
     the erase label changes while it is active) */
  var REMOVE_TEXT = [/^\u25A3?\s*Change image$/i, /^\u25E8?\s*Eras(e|ing)/i, /^T?\s*Add a text box$/i];
  function isCornerButton(b) {
    var s = b.getAttribute('style') || '';
    return s.indexOf('position: absolute') > -1 && s.indexOf('width: 52px') > -1 && s.indexOf('border-radius: 26px') > -1;
  }
  function hideButtons(d) {
    var all = d.querySelectorAll('button');
    for (var i = 0; i < all.length; i++) {
      var b = all[i];
      var t = b.getAttribute('title') || b.getAttribute('aria-label') || (b.textContent || '').replace(/\s+/g, ' ').trim();
      if (REMOVE_TITLES.indexOf(t) < 0 && !isCornerButton(b)
          && !REMOVE_TEXT.some(function (re) { return re.test((b.textContent || '').replace(/\s+/g, ' ').trim()); })) continue;
      b.style.display = 'none';
      b.setAttribute('data-acp-removed', 'button');
      /* the toolbar frames each cluster with 1px dividers: when a cluster is
         emptied, its box and the divider before it go too, or a gap is left */
      var box = b.parentElement;
      var isBar = box && [].some.call(box.children, function (c) { return /width: 1px/.test(c.getAttribute('style') || ''); });
      if (!box || isBar || !/display: (flex|grid)/.test(box.getAttribute('style') || '')) box = b;
      var alive = [].some.call(box === b ? [] : box.children, function (c) { return c.style.display !== 'none'; });
      if (!alive) {
        box.style.display = 'none';
        var prev = box.previousElementSibling;
        if (prev && /width: 1px/.test(prev.getAttribute('style') || '')) prev.style.display = 'none';
        else {
          /* first in the bar: the divider after it goes instead */
          var next = box.nextElementSibling;
          if (next && /width: 1px/.test(next.getAttribute('style') || '')) next.style.display = 'none';
        }
      }
    }
  }
  function fitBoxes(d) {
    if (d.getElementById('acp-fit')) return;
    var s = d.createElement('style');
    s.id = 'acp-fit';
    s.textContent = FIT_CSS;
    (d.head || d.body).appendChild(s);
  }
  /* While a text box is being edited the tool swaps in a textarea, which has
     no natural size — so it is measured and sized to its own lines, as the
     text is typed, and the box keeps hugging the text. */
  function hugEditors(d) {
    var tas = d.querySelectorAll('[style*="cursor: move"] > textarea');
    if (!tas.length) return;
    var m = d.getElementById('acp-measure');
    if (!m) {
      m = d.createElement('span');
      m.id = 'acp-measure';
      m.style.cssText = 'position:absolute;left:-99999px;top:0;visibility:hidden;white-space:pre;pointer-events:none;';
      d.body.appendChild(m);
    }
    for (var i = 0; i < tas.length; i++) {
      var ta = tas[i], cs = d.defaultView.getComputedStyle(ta);
      m.style.font = cs.font;
      m.style.letterSpacing = cs.letterSpacing;
      var lines = (ta.value || ' ').split('\n'), widest = 0;
      for (var k = 0; k < lines.length; k++) {
        m.textContent = lines[k] || ' ';
        widest = Math.max(widest, m.getBoundingClientRect().width);
      }
      var pad = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
      /* a little room at the end so the caret shows after the last letter */
      ta.style.width = Math.max(24, Math.ceil(widest) + pad + 12) + 'px';
      /* height from the line count, not the textarea's default rows */
      ta.rows = 1;
      var lh = parseFloat(cs.lineHeight);
      if (!lh || isNaN(lh)) lh = parseFloat(cs.fontSize) * 1.05;
      ta.style.height = Math.ceil(lines.length * lh) + 'px';
      /* a fresh box opens with its placeholder selected, so typing replaces
         "type here" instead of carrying on after it */
      if (!ta.__acpArmed) {
        ta.__acpArmed = true;
        if (/^type here$/i.test((ta.value || '').trim())) { try { ta.focus(); ta.select(); } catch (e) {} }
      }
    }
    if (!d.__acpHug) {
      d.__acpHug = true;
      d.addEventListener('input', function (e) {
        if (e.target && e.target.tagName === 'TEXTAREA') hugEditors(d);
      }, true);
    }
  }

  /* ---------- Group / Ungroup ----------
     Asked for: pieces on the design can be gathered into a group that moves as
     one. The tool has no such feature and cannot be edited, so it is built
     from outside: two buttons beside Duplicate, a pick mode where clicking
     pieces in the safe area chooses / unchooses them, and a drag helper that,
     when one grouped piece is dragged, moves the rest by the same distance
     using the tool's own mouse handling (so the tool records the new spots
     itself). Groups live only for the session, like the rest of the design. */
  var SEL_BORDER = 'rgb(255, 45, 155)';
  var picking = false, pending = [], groups = [], gseq = 0, busy = false;
  var drag = null;

  function wrappers(d) {
    return [].filter.call(d.querySelectorAll('[style*="cursor: move"]'), function (w) {
      return w.parentElement && /dashed/.test(w.parentElement.getAttribute('style') || '');
    });
  }
  function wrapperOf(el) {
    while (el && el.nodeType === 1) {
      if (/cursor: move/.test(el.getAttribute('style') || '')) return el;
      el = el.parentElement;
    }
    return null;
  }
  function selectedWrapper(d) {
    return wrappers(d).filter(function (w) {
      return [].some.call(w.children, function (c) {
        var s = c.getAttribute('style') || '';
        return s.indexOf(SEL_BORDER) > -1 && s.indexOf('inset: 0') > -1;
      });
    })[0] || null;
  }
  function groupOf(w) {
    var id = w && w.getAttribute('data-acp-group');
    if (!id) return null;
    var g = groups.filter(function (g) { return g.id === id; })[0];
    if (!g) return null;
    g.members = g.members.filter(function (m) { return m.isConnected; });
    return g;
  }
  function wrappersOf(d) {
    var L = logicOf(d), area = L && L.areaRef && L.areaRef.current;
    if (!area) return [];
    return [].slice.call(area.children).filter(function (n) { return /translate\(-50%, -50%\)/.test(n.getAttribute('style') || ''); });
  }
  function idOfWrapper(L, w) {
    var s = w.getAttribute('style') || '';
    var ml = /left:\s*([\d.]+)%/.exec(s), mt = /top:\s*([\d.]+)%/.exec(s);
    if (!ml || !mt) return null;
    var best = null, bd = 1e9;
    (L.state.els || []).forEach(function (x) {
      if (x.kind === 'product') return;
      var dd = Math.abs(x.left - +ml[1]) + Math.abs(x.top - +mt[1]);
      if (dd < bd) { bd = dd; best = x; }
    });
    return best && bd < 0.5 ? best.id : null;
  }
  function dissolve(g) {
    g.members.forEach(function (m) { m.removeAttribute('data-acp-group'); });
    groups = groups.filter(function (x) { return x !== g; });
  }
  function setPicking(on) {
    picking = on;
    if (!on) {
      pending.forEach(function (w) { w.removeAttribute('data-acp-sel'); });
      pending = [];
    }
  }
  function formGroup() {
    var live = pending.filter(function (w) { return w.isConnected; });
    if (live.length < 2) { setPicking(false); return; }
    /* a piece already in a group moves over to the new one */
    live.forEach(function (w) { var g = groupOf(w); if (g) dissolve(g); });
    var g = { id: 'g' + (++gseq), members: live };
    live.forEach(function (w) { w.setAttribute('data-acp-group', g.id); });
    groups.push(g);
    setPicking(false);
  }

  function fire(d, type, target, x, y) {
    var w = d.defaultView;
    target.dispatchEvent(new w.MouseEvent(type, {
      bubbles: true, cancelable: true, view: w, clientX: x, clientY: y,
      button: 0, buttons: type === 'mouseup' ? 0 : 1
    }));
  }
  /* move one piece by (dx, dy) the way a hand would: press, drag, release */
  function nudge(d, w, dx, dy) {
    var r = w.getBoundingClientRect(), x = r.left + r.width / 2, y = r.top + r.height / 2;
    fire(d, 'mousedown', w, x, y);
    fire(d, 'mousemove', d, x + dx / 2, y + dy / 2);
    fire(d, 'mousemove', d, x + dx, y + dy);
    fire(d, 'mouseup', d, x + dx, y + dy);
  }

  function wireGroups(d) {
    if (d.__acpGroups) return;
    d.__acpGroups = true;
    d.addEventListener('mousedown', function (e) {
      if (busy || e.button !== 0) return;
      var w = wrapperOf(e.target);
      if (picking) {
        if (!w) return;
        e.stopPropagation(); e.preventDefault();
        var i = pending.indexOf(w);
        if (i > -1) { pending.splice(i, 1); w.removeAttribute('data-acp-sel'); }
        else { pending.push(w); w.setAttribute('data-acp-sel', ''); }
        return;
      }
      /* a press on a resize handle or the piece body both start the tool's
         own drag; only the body drag should carry the group along */
      var g = groupOf(w);
      if (!g) return;
      var ts = e.target.getAttribute('style') || '';
      if (/cursor: [^;]*(resize|grab)/.test(ts)) return;
      /* asked for: a grouped piece drags its group, and whatever else is
         chosen with it (shift-click) comes along too */
      var Lg = logicOf(d), extra = [];
      if (Lg && !(e.shiftKey || e.metaKey || e.ctrlKey)) {
        var idOf = function (m) { return idOfWrapper(Lg, m); };
        var gids = g.members.map(idOf);
        var selIds = (Lg.state.sel || []).filter(function (id) { return gids.indexOf(id) === -1; });
        if (selIds.length && (Lg.state.sel || []).indexOf(idOf(w)) > -1) {
          extra = wrappersOf(d).filter(function (m) { return selIds.indexOf(idOf(m)) > -1; });
          var keep = Lg.state.sel.slice();
          setTimeout(function () { try { Lg.setState({ sel: keep }); } catch (err) {} }, 0);
        }
      }
      drag = { leader: w, x: e.clientX, y: e.clientY, dx: 0, dy: 0,
        others: g.members.filter(function (m) { return m !== w; }).concat(extra) };
    }, true);
    d.addEventListener('mousemove', function (e) {
      if (!drag || busy) return;
      drag.dx = e.clientX - drag.x; drag.dy = e.clientY - drag.y;
      drag.others.forEach(function (m) {
        m.style.marginLeft = drag.dx + 'px';
        m.style.marginTop = drag.dy + 'px';
      });
    }, true);
    d.addEventListener('mouseup', function (e) {
      if (!drag || busy) return;
      var done = drag; drag = null;
      if (Math.abs(done.dx) < 1 && Math.abs(done.dy) < 1) {
        done.others.forEach(function (m) { m.style.marginLeft = ''; m.style.marginTop = ''; });
        return;
      }
      /* let the tool finish the leader first, then walk the rest over */
      setTimeout(function () {
        busy = true;
        try {
          done.others.forEach(function (m) {
            if (!m.isConnected) return;
            m.style.marginLeft = ''; m.style.marginTop = '';
            nudge(d, m, done.dx, done.dy);
          });
          /* hand the selection back to the piece that was dragged */
          if (done.leader.isConnected) nudge(d, done.leader, 0, 0);
        } catch (err) {}
        busy = false;
      }, 0);
    }, true);
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && picking) setPicking(false);
      /* LightBurn hotkeys: Ctrl/Cmd+Shift+H or plain H mirrors horizontally,
         Ctrl/Cmd+Shift+V or plain V mirrors vertically — not while typing */
      var k = (e.key || '').toLowerCase();
      if (k !== 'h' && k !== 'v') return;
      var t = e.target, tag = t && t.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || (t && t.isContentEditable)) return;
      var Lk = logicOf(d);
      if (!Lk || Lk.state.editingId != null || Lk.state.step !== 'Design') return;
      var combo = (e.ctrlKey || e.metaKey) && e.shiftKey && !e.altKey;
      var plain = !e.ctrlKey && !e.metaKey && !e.altKey && !e.shiftKey;
      if (!combo && !plain) return;
      e.preventDefault(); e.stopPropagation();
      arrangeAct(d, k === 'h' ? 'mirrorH' : 'mirrorV');
    }, true);
    /* the tool absorbs inserted buttons into its own render, which drops any
       listener set on them — so every added button is handled from here */
    d.addEventListener('click', function (e) {
      var sb = e.target && e.target.closest && e.target.closest('button[style*="width: 86px"]');
      if (sb && isSideBtn(sb)) {
        var Lsb = logicOf(d);
        if (twoSides(Lsb)) {
          /* two real sides: switch side directly, the tool's own handler
             is bypassed so the two never disagree */
          e.stopPropagation(); e.preventDefault();
          var wantSide = sideIdOf(sb);
          if (Lsb) Lsb.setState({ side: wantSide, sel: [], editingId: null });
          face = sideIndex(wantSide);
          setTimeout(function () { markFaces(d); }, 50);
          return;
        }
        e.stopPropagation(); e.preventDefault();
        var L2 = logicOf(d);
        var which = sideIdOf(sb) === 'back' ? 1 : 0;
        mode = which ? 'back' : 'front';
        if (L2) showFace(d, L2, which);
        markFaces(d); sideChooser(d);
        return;
      }
      var rt = e.target && e.target.closest && e.target.closest('[data-acp-review]');
      if (rt) {
        e.stopPropagation(); e.preventDefault();
        var L5 = logicOf(d), want = rt.getAttribute('data-acp-review');
        if (L5 && (L5.state.side || 'front') !== want) {
          if (twoSides(L5)) L5.setState({ side: want, sel: [], editingId: null });
          else { face = want === 'back' ? 1 : 0; mode = want; showFace(d, L5, face); }
        }
        return;
      }
      var sc = e.target && e.target.closest && e.target.closest('[data-acp-side]');
      if (sc) { e.stopPropagation(); e.preventDefault(); chooseMode(d, sc.getAttribute('data-acp-side')); return; }
      var b = e.target && e.target.closest && e.target.closest('[data-acp-btn]');
      if (b && (b.getAttribute('data-acp-btn') === 'arrange-group' || b.getAttribute('data-acp-btn') === 'arrange-div')) return;
      if (!b) return;
      var kind = b.getAttribute('data-acp-btn');
      var ft = e.target.closest('[data-acp-file], [data-acp-file-remove]');
      if (ft) {
        e.stopPropagation(); e.preventDefault();
        var L4 = logicOf(d);
        if (!L4) return;
        var fid = ft.getAttribute('data-acp-file') || ft.getAttribute('data-acp-file-remove');
        if (ft.hasAttribute('data-acp-file-remove')) {
          L4.setState(function (st) { return { uploads: (st.uploads || []).filter(function (u) { return u.id !== fid; }) }; });
        } else {
          var it = (L4.state.uploads || []).filter(function (u) { return u.id === fid; })[0];
          if (it) placeFile(d, L4, it);
        }
        return;
      }
      if (kind === 'upload-wrap') kind = 'upload';
      if (kind === 'group') {
        e.stopPropagation();
        /* asked for: pieces already chosen (cmd/shift-click) group in one click
           and are draggable as one straight away; with nothing chosen the
           pick-then-click flow is kept */
        var Lgp = logicOf(d), chosen = [];
        if (Lgp && (Lgp.state.sel || []).length > 1) {
          var selIds2 = Lgp.state.sel;
          chosen = wrappersOf(d).filter(function (m) { return selIds2.indexOf(idOfWrapper(Lgp, m)) > -1; });
        }
        if (chosen.length > 1) { pending = chosen; picking = true; formGroup(); }
        else if (picking) formGroup(); else setPicking(true);
        groupButtons(d);
      } else if (kind === 'ungroup') {
        e.stopPropagation();
        var g = groupOf(selectedWrapper(d));
        if (g) dissolve(g);
        setPicking(false);
        groupButtons(d);
      } else if (kind === 'addtext') {
        e.stopPropagation();
        addText(d);
      } else if (kind === 'arr') {
        e.stopPropagation();
        arrangeAct(d, b.getAttribute('data-acp-arr'));
      } else if (kind === 'upload') {
        e.stopPropagation();
        openUpload(d);
      } else if (kind === 'colour') {
        e.stopPropagation();
        var inp = b.querySelector('input');
        if (inp && e.target !== inp) {
          var L3 = logicOf(d);
          try { var a = L3.state.els.filter(function (x) { return L3.state.sel.indexOf(x.id) > -1; }).slice(-1)[0]; if (a && /^#[0-9a-f]{6}$/i.test(a.color || '')) inp.value = a.color; } catch (err) {}
          inp.click();
        }
      }
    }, true);
  }

  function findAddBox(d) {
    return [].filter.call(d.querySelectorAll('button'), function (b) {
      return /add a text box/i.test(b.textContent || '');
    })[0];
  }
  function addText(d) {
    var t = findAddBox(d);
    if (t) { t.click(); return; }
    /* the panel with the real button is not open: open it, then press */
    var L = logicOf(d);
    if (L) try { L.setState({ tool: 'text' }); } catch (err) {}
    var n = 0, poll = setInterval(function () {
      var t2 = findAddBox(d);
      if (t2) { clearInterval(poll); t2.click(); }
      else if (++n > 20) clearInterval(poll);
    }, 50);
  }

  /* Asked for: the safe area works with the mouse, for Our Product and Your
     Product alike — drag its dashed edge to resize, drag inside it (on empty
     space) to move it, drag on empty space to rubber-band several pieces,
     double-click empty space to add a text box there, and hovering shows its
     size in mm. The chosen box is kept per workspace and re-applied after
     every paint, because the tool redraws it. Toolbar handling is untouched:
     everything here listens on the canvas alone. */
  var SAFE = { ours: null, yours: null };
  var safeDrag = null, safeHover = false;
  function safeBox(d) {
    var L = logicOf(d), area = L && L.areaRef && L.areaRef.current;
    return area && area.parentElement ? { L: L, area: area, board: area.parentElement } : null;
  }
  function safeInsetPct(s) {
    var b = s.board.getBoundingClientRect(), a = s.area.getBoundingClientRect();
    return { t: (a.top - b.top) / b.height * 100, l: (a.left - b.left) / b.width * 100, b: (b.bottom - a.bottom) / b.height * 100, r: (b.right - a.right) / b.width * 100 };
  }
  function applySafe(d) {
    var s = safeBox(d);
    if (!s) return;
    var box = SAFE[ws];
    if (box) {
      var want = box.t.toFixed(3) + '% ' + box.r.toFixed(3) + '% ' + box.b.toFixed(3) + '% ' + box.l.toFixed(3) + '%';
      if (s.area.style.inset !== want) s.area.style.inset = want;
    }
    s.area.style.cursor = safeHover ? 'move' : '';
    if (!s.board.__acpSafe) wireSafe(d, s.board);
    var tip = s.board.querySelector('[data-acp-safe-tip]');
    if (tip && tip.style.display !== 'none') tipText(d, s, tip);
  }
  function mmOf(s, pct) {
    var inches = s.L.state.sizeIn || 2;
    return pct / 100 * inches * 25.4;
  }
  function tipText(d, s, tip) {
    var i = safeInsetPct(s);
    var w = mmOf(s, 100 - i.l - i.r), h = mmOf(s, 100 - i.t - i.b);
    tip.textContent = w.toFixed(1) + ' × ' + h.toFixed(1) + ' mm';
  }
  function edgeAt(s, x, y) {
    var a = s.area.getBoundingClientRect(), m = 7;
    var inX = x > a.left - m && x < a.right + m, inY = y > a.top - m && y < a.bottom + m;
    if (!inX || !inY) return null;
    var e = '';
    if (Math.abs(y - a.top) <= m) e += 'n'; else if (Math.abs(y - a.bottom) <= m) e += 's';
    if (Math.abs(x - a.left) <= m) e += 'w'; else if (Math.abs(x - a.right) <= m) e += 'e';
    return e || 'in';
  }
  var CURSORS = { n: 'ns-resize', s: 'ns-resize', e: 'ew-resize', w: 'ew-resize', ne: 'nesw-resize', sw: 'nesw-resize', nw: 'nwse-resize', se: 'nwse-resize' };
  function onPiece(t, s) {
    var n = t;
    while (n && n !== s.board) {
      if (/translate\(-50%, -50%\)/.test(n.getAttribute && n.getAttribute('style') || '')) return n;
      n = n.parentElement;
    }
    return null;
  }
  function wireSafe(d, board) {
    board.__acpSafe = true;
    var tip = d.createElement('div');
    tip.setAttribute('data-acp-safe-tip', '');
    tip.setAttribute('style', 'position: absolute; right: 10px; bottom: 8px; z-index: 30; display: none; pointer-events: none;'
      + 'background: rgb(223, 245, 227); color: rgb(22, 101, 52); font-size: 12px; padding: 2px 9px; border-radius: 9px; white-space: nowrap;');
    board.appendChild(tip);
    var band = d.createElement('div');
    band.setAttribute('data-acp-band', '');
    band.setAttribute('style', 'position: absolute; z-index: 29; display: none; pointer-events: none; border: 1px solid rgb(255, 45, 155); background: rgba(255, 45, 155, 0.08);');
    board.appendChild(band);
    board.addEventListener('mousemove', function (e) {
      var s = safeBox(d);
      if (!s || safeDrag) return;
      var L = s.L;
      if (L.state.step !== 'Design' || !L.state.safeOn) { tip.style.display = 'none'; return; }
      var inBoard = e.target === board || board.contains(e.target);
      tip.style.display = inBoard ? 'block' : 'none';
      if (inBoard) tipText(d, s, tip);
      var edge = null;
      safeHover = false;
      board.style.cursor = '';
      s.area.style.cursor = '';
    });
    board.addEventListener('mouseleave', function () { tip.style.display = 'none'; board.style.cursor = ''; safeHover = false; });
    board.addEventListener('mousedown', function (e) {
      if (e.button !== 0 || picking || busy) return;
      var s = safeBox(d);
      if (!s || s.L.state.step !== 'Design') return;
      if (onPiece(e.target, s)) return;
      if (e.target.closest && e.target.closest('button, input, textarea, [contenteditable="true"]')) return;
      var edge = null; /* asked for: the safe area is locked — no resize, no move */
      var b = s.board.getBoundingClientRect();
      safeDrag = { kind: 'band', x0: e.clientX, y0: e.clientY, b: b, additive: e.shiftKey || e.metaKey || e.ctrlKey };
      e.preventDefault(); e.stopPropagation();
    }, true);
    d.addEventListener('mousemove', function (e) {
      if (!safeDrag) return;
      var s = safeBox(d);
      if (!s) { safeDrag = null; return; }
      var dx = (e.clientX - safeDrag.x0) / safeDrag.b.width * 100, dy = (e.clientY - safeDrag.y0) / safeDrag.b.height * 100;
      var st = safeDrag.start;
      if (safeDrag.kind === 'band') {
        var x1 = Math.min(e.clientX, safeDrag.x0), y1 = Math.min(e.clientY, safeDrag.y0);
        var x2 = Math.max(e.clientX, safeDrag.x0), y2 = Math.max(e.clientY, safeDrag.y0);
        band.style.display = 'block';
        band.style.left = (x1 - safeDrag.b.left) + 'px'; band.style.top = (y1 - safeDrag.b.top) + 'px';
        band.style.width = (x2 - x1) + 'px'; band.style.height = (y2 - y1) + 'px';
        safeDrag.rect = { x1: x1, y1: y1, x2: x2, y2: y2 };
      }
    }, true);
    d.addEventListener('mouseup', function (e) {
      if (!safeDrag) return;
      var done = safeDrag; safeDrag = null;
      var s = safeBox(d);
      band.style.display = 'none';
      if (!s) return;
      if (done.kind === 'band') {
        var r = done.rect;
        if (!r || (r.x2 - r.x1 < 4 && r.y2 - r.y1 < 4)) {
          /* a plain click on empty space: clear the selection like the tool does */
          if (!done.additive) s.L.setState({ sel: [], editingId: null });
          return;
        }
        var side = s.L.state.side || 'front', hits = [];
        wrappersOf(d).forEach(function (w) {
          var q = w.getBoundingClientRect();
          if (q.right < r.x1 || q.left > r.x2 || q.bottom < r.y1 || q.top > r.y2) return;
          var id = idOfWrapper(s.L, w);
          if (id != null) hits.push(id);
        });
        var sel = done.additive ? (s.L.state.sel || []).concat(hits.filter(function (id) { return (s.L.state.sel || []).indexOf(id) === -1; })) : hits;
        s.L.setState({ sel: sel, editingId: null });
      } else if (done.kind === 'move' && !done.moved) {
        s.L.setState({ sel: [], editingId: null });
      }
    }, true);
    board.addEventListener('dblclick', function (e) {
      var s = safeBox(d);
      if (!s || s.L.state.step !== 'Design' || onPiece(e.target, s)) return;
      if (e.target.closest && e.target.closest('button, input, textarea')) return;
      e.preventDefault(); e.stopPropagation();
      var b = s.board.getBoundingClientRect();
      var left = clamp((e.clientX - b.left) / b.width * 100, 5, 95), top = clamp((e.clientY - b.top) / b.height * 100, 5, 95);
      var before = (s.L.state.els || []).map(function (x) { return x.id; });
      addText(d);
      var n = 0, poll = setInterval(function () {
        var L2 = logicOf(d);
        var fresh = L2 && (L2.state.els || []).filter(function (x) { return before.indexOf(x.id) === -1 && x.type === 'text'; }).slice(-1)[0];
        if (fresh) { clearInterval(poll); L2.patchById(fresh.id, { left: left, top: top }, true); }
        else if (++n > 30) clearInterval(poll);
      }, 50);
    }, true);
  }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* Asked for: Remove BG shows a percentage while it works, so the wait
     makes sense. The tool tracks a stage string but never shows it; the
     button's label carries it while busy. Between the tool's stage steps the
     number creeps up on its own so it never sits still. */
  var bgTick = null, bgPct = 0, bgLast = '';
  /* Asked for: a battery that fills while the background is being removed,
     so the wait is visibly progress and not a stuck button */
  function paintBattery(d, btn, pct) {
    var bat = btn.querySelector('[data-acp-battery]');
    if (!bat) {
      bat = d.createElement('span');
      bat.setAttribute('data-acp-battery', '');
      bat.setAttribute('style', 'display: inline-block; position: relative; width: 24px; height: 12px; border: 1.5px solid rgb(30, 42, 138); border-radius: 3px; margin-right: 7px; vertical-align: -2px; box-sizing: border-box; flex: 0 0 24px; padding: 1.5px;');
      var nub = d.createElement('span');
      nub.setAttribute('style', 'position: absolute; right: -4.5px; top: 2px; width: 3px; height: 5px; background: rgb(30, 42, 138); border-radius: 0 1.5px 1.5px 0;');
      var fill = d.createElement('span');
      fill.setAttribute('data-acp-battery-fill', '');
      fill.setAttribute('style', 'display: block; height: 100%; width: 4%; background: rgb(30, 42, 138); border-radius: 1px; transition: width .18s linear; animation: acpBatteryPulse 1.1s ease-in-out infinite;');
      bat.appendChild(fill);
      bat.appendChild(nub);
      if (!d.getElementById('acp-battery-kf')) {
        var st = d.createElement('style'); st.id = 'acp-battery-kf';
        st.textContent = '@keyframes acpBatteryPulse{0%,100%{opacity:1}50%{opacity:.45}}';
        d.head.appendChild(st);
      }
      btn.insertBefore(bat, btn.firstChild);
      /* the tool's own glyph steps aside for the battery while busy */
      var glyph = bat.nextElementSibling;
      if (glyph && glyph.tagName === 'SPAN' && glyph !== (btn.querySelector('span:last-child'))) { glyph.style.display = 'none'; glyph.setAttribute('data-acp-battery-hid', ''); }
    }
    bat.querySelector('[data-acp-battery-fill]').style.width = Math.max(4, Math.min(100, pct)) + '%';
  }
  function clearBattery(btn) {
    var bat = btn.querySelector('[data-acp-battery]');
    if (bat) bat.parentElement.removeChild(bat);
    var g = btn.querySelector('[data-acp-battery-hid]');
    if (g) { g.style.display = ''; g.removeAttribute('data-acp-battery-hid'); }
  }
  function bgProgress(d) {
    var L = logicOf(d);
    if (!L) return;
    var btn = [].filter.call(d.querySelectorAll('button'), function (b) { return /Remove BG|Removing|Restore BG|Undo BG/i.test(b.textContent || '') || b.hasAttribute('data-acp-bgpct'); })[0];
    if (!btn) return;
    var lab = btn.querySelector('span:last-child') || btn;
    if (L.state.bgBusy) {
      var stage = L.state.bgStage || '';
      var m = /(\d+)%/.exec(stage);
      var floor = /Prepar/i.test(stage) ? 2 : /Loading/i.test(stage) ? 5 : /Cutting|Removing/i.test(stage) ? 55 : 5;
      if (m) floor = 5 + Math.round(+m[1] * 0.5); /* model download is the first half */
      if (stage !== bgLast) { bgLast = stage; bgPct = Math.max(bgPct, floor); }
      if (!bgTick) {
        bgTick = setInterval(function () {
          if (!L.state.bgBusy) { clearInterval(bgTick); bgTick = null; bgPct = 0; bgLast = ''; return; }
          var cap = /Cutting|Removing/i.test(L.state.bgStage || '') ? 96 : 50;
          if (bgPct < cap) bgPct += Math.max(0.2, (cap - bgPct) / 40);
          var b2 = d.querySelector('[data-acp-bgpct]');
          var l2 = b2 && (b2.querySelector('span:last-child') || b2);
          if (l2) l2.textContent = 'Removing\u2026 ' + Math.round(bgPct) + '%';
          if (b2) paintBattery(d, b2, bgPct);
        }, 120);
      }
      if (!btn.hasAttribute('data-acp-bgpct')) { btn.setAttribute('data-acp-bgpct', ''); btn.setAttribute('data-acp-bglabel', lab.textContent); }
      lab.textContent = 'Removing\u2026 ' + Math.round(bgPct) + '%';
      paintBattery(d, btn, bgPct);
    } else if (btn.hasAttribute('data-acp-bgpct')) {
      clearBattery(btn);
      btn.removeAttribute('data-acp-bgpct');
      btn.removeAttribute('data-acp-bglabel');
      bgPct = 0; bgLast = '';
      try { L.forceUpdate(); } catch (e) {}
    }
  }
  /* Asked for: the three text-alignment buttons (left / centre / right) are
     taken out of the toolbar */
  function hideTextAlign(d) {
    [].forEach.call(d.querySelectorAll('button[title^="Align text"]'), function (b) {
      if (b.style.display !== 'none') { b.style.display = 'none'; b.setAttribute('data-acp-removed', 'text-align'); }
      var g = b.parentElement;
      if (g && /repeat\(3, 30px\)/.test(g.getAttribute('style') || '') && g.style.gridTemplateColumns !== 'repeat(3, 30px)') return;
    });
  }

  /* Asked for: the review summary names the chosen product as its first line
     (Your Product: the visitor's own upload) */
  function reviewProductLine(d) {
    var L = logicOf(d);
    if (!L || L.state.step !== 'Review') return;
    var ul = [].filter.call(d.querySelectorAll('ul'), function (u) { return /Shape:/.test(u.textContent || ''); })[0];
    if (!ul) return;
    var title = ws === 'yours' ? 'Your own product' : (L.state.shopPick && L.state.shopPick.title) || '';
    /* asked for: the Shape and Size lines are taken out */
    [].forEach.call(ul.children, function (c) {
      if (/^(Shape|Size):/.test((c.textContent || '').trim()) && c.style.display !== 'none') { c.style.display = 'none'; c.setAttribute('data-acp-removed', 'review-line'); }
    });
    if (!title) return;
    var li = ul.querySelector('[data-acp-product-line]');
    if (!li) {
      li = d.createElement('li');
      li.setAttribute('data-acp-product-line', '');
      ul.insertBefore(li, ul.firstChild);
    }
    var want = 'Product: ' + title;
    if (li.textContent !== want) li.textContent = want;
  }

  /* Asked for: one more note under "Check all sides of your design" — colours
     on screen are for editing only; the engraving comes out in a shade of
     white */
  function reviewColourNote(d) {
    var L = logicOf(d);
    if (!L || L.state.step !== 'Review') return;
    var li = [].filter.call(d.querySelectorAll('li'), function (l) { return /Check all sides of your design/.test(l.textContent || ''); })[0];
    if (!li || li.parentElement.querySelector('[data-acp-colour-note]')) return;
    var n = d.createElement('li');
    n.setAttribute('data-acp-colour-note', '');
    n.textContent = 'Colours on uploads, text and icons are for editing only — the engraving itself comes out in a shade of white';
    li.insertAdjacentElement('afterend', n);
  }

  /* Asked for: no quote request from the tool. The Your Product review saves
     the mockup PNG instead; the visitor emails it to the shop by hand. */
  function quoteToDownload(d) {
    var L = logicOf(d);
    if (!L || L.state.step !== 'Review') return;
    [].forEach.call(d.querySelectorAll('button'), function (b) {
      if ((b.textContent || '').trim() === 'Send for Quote') b.textContent = 'Download mockup';
    });
    [].forEach.call(d.querySelectorAll('p'), function (p) {
      var t = (p.textContent || '').trim();
      if (t === 'Review your design before requesting a quote.') p.textContent = 'Review your design, then download the mockup.';
      else if (/^Pricing and lead time come back with your quote/.test(t)) p.textContent = 'Download the mockup and email it to contact@archerlaser.ca — pricing and lead time come back by reply. No payment now.';
      else if (/^Quote request sent/.test(t)) p.textContent = 'Mockup saved — email it to contact@archerlaser.ca and we’ll come back with pricing and lead time.';
    });
  }

  /* The tool's "Added to cart" line names its own built-in item ("custom
     Button"). It names the Shopify product and the chosen side instead. */
  function cartLine(d) {
    var L = logicOf(d);
    if (!L || L.state.step !== 'Review') return;
    var span = [].filter.call(d.querySelectorAll('span'), function (s) { return /^Added to cart/.test((s.textContent || '').trim()) && !s.children.length; })[0];
    if (!span) return;
    var p = L.state.shopPick;
    var name = ws === 'yours' ? 'Your own product' : (p && p.title) || '';
    if (!name) return;
    var side = mode === 'both' ? 'both sides' : mode === 'back' ? 'back' : 'front';
    var want = 'Added to cart \u2014 ' + (L.state.qty || 1) + ' \u00d7 ' + name + ' (' + side + ')';
    if (span.textContent !== want) span.textContent = want;
  }

  /* the tool's built-in mock "Shopify checkout" card (email / shipping /
     Continue to payment) is not the real checkout; if it ever shows, the state
     is put back so the real "Checkout with Shopify" button is what's seen */
  function noMockCheckout(d) {
    var L = logicOf(d);
    if (!L) return;
    loadVariants(d, L); hookCheckout(d, L); /* also wires Send for Quote, which has no side chooser */
    if (L.state.cart !== 'checkout') return;
    if (L.state.shopPick && (L.state.shopPick.variantId || L.state.shopPick.acpVariant)) L.setState({ cart: 'added' });
  }

  function groupButtons(d) {
    var dups = d.querySelectorAll('button[title^="Duplicate"]');
    for (var i = 0; i < dups.length; i++) groupButtonsIn(d, dups[i]);
  }
  function groupButtonsIn(d, dup) {
    var row = dup.parentElement;
    var gb = row.querySelector('[data-acp-btn="group"]');
    var ub = row.querySelector('[data-acp-btn="ungroup"]');
    if (!gb) {
      gb = make(d, dup, 'group', 'Group');
      ub = make(d, dup, 'ungroup', 'Ungroup');
      dup.insertAdjacentElement('afterend', ub);
      dup.insertAdjacentElement('afterend', gb);
    }
    /* Asked for: Group and Ungroup live in the arrangement bar only; the pair
       in the lower toolbar is kept out of sight */
    gb.style.display = 'none'; ub.style.display = 'none';
    gb.setAttribute('data-acp-removed', 'group'); ub.setAttribute('data-acp-removed', 'group');
    var sel = selectedWrapper(d);
    /* Delete, asked to be more obvious: same icon + label treatment as the
       group buttons, in place of the bare glyph */
    var del = row.querySelector('button[title="Delete"]');
    if (del && !del.__acpStyled) {
      del.__acpStyled = true;
      var look = make(d, dup, 'delete', 'Delete');
      del.textContent = '';
      while (look.firstChild) del.appendChild(look.firstChild);
      del.setAttribute('style', look.getAttribute('style'));
      del.style.color = 'rgb(180, 84, 31)';
    }
    var live = pending.filter(function (w) { return w.isConnected; }).length;
    gb.title = picking
      ? (live > 1 ? 'Group the ' + live + ' chosen pieces' : 'Click pieces to choose them, then click again to group')
      : 'Group: choose pieces to move together';
    gb.style.background = picking ? 'rgb(17, 24, 39)' : 'transparent';
    gb.style.color = picking ? '#fff' : 'rgb(17, 24, 39)';
    gb.style.borderRadius = '6px';
    var can = !!groupOf(sel);
    ub.title = can ? 'Ungroup' : 'Ungroup (select a grouped piece first)';
    ub.style.opacity = can ? '1' : '.35';
    ub.disabled = !can;
  }
  function make(d, like, kind, label) {
    var b = d.createElement('button');
    b.type = 'button';
    b.setAttribute('data-acp-btn', kind);
    b.setAttribute('style', like.getAttribute('style') || '');
    b.style.width = 'auto';
    b.style.flex = '0 0 auto';
    b.style.display = 'flex';
    b.style.alignItems = 'center';
    b.style.gap = '6px';
    b.style.padding = '0 6px';
    b.style.fontSize = '14px';
    b.style.fontWeight = '600';
    b.style.fontFamily = 'inherit';
    b.style.lineHeight = '1';
    /* dotted selection frame holding two overlapping pieces */
    var ns = 'http://www.w3.org/2000/svg';
    var svg = d.createElementNS(ns, 'svg');
    svg.setAttribute('width', '18'); svg.setAttribute('height', '18');
    svg.setAttribute('viewBox', '0 0 18 18'); svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '1.4');
    svg.setAttribute('aria-hidden', 'true');
    var frame = d.createElementNS(ns, 'rect');
    frame.setAttribute('x', '1'); frame.setAttribute('y', '1');
    frame.setAttribute('width', '16'); frame.setAttribute('height', '16');
    frame.setAttribute('stroke-dasharray', '1.6 1.6');
    var a = d.createElementNS(ns, 'rect');
    a.setAttribute('x', '4.5'); a.setAttribute('y', '4.5');
    a.setAttribute('width', '6'); a.setAttribute('height', '6'); a.setAttribute('rx', '1');
    var c = d.createElementNS(ns, 'rect');
    c.setAttribute('x', '7.5'); c.setAttribute('y', '7.5');
    c.setAttribute('width', '6'); c.setAttribute('height', '6'); c.setAttribute('rx', '1');
    c.setAttribute('fill', '#fff');
    svg.appendChild(frame); svg.appendChild(a); svg.appendChild(c);
    if (kind === 'ungroup') {
      /* same frame, the pieces broken into loose dots */
      svg.removeChild(a); svg.removeChild(c);
      [[4.5, 4.5], [9, 4.5], [13.5, 4.5], [4.5, 9], [13.5, 9], [4.5, 13.5], [9, 13.5], [13.5, 13.5]].forEach(function (p) {
        var dot = d.createElementNS(ns, 'rect');
        dot.setAttribute('x', p[0] - 0.9); dot.setAttribute('y', p[1] - 0.9);
        dot.setAttribute('width', '1.8'); dot.setAttribute('height', '1.8');
        dot.setAttribute('fill', 'currentColor'); dot.setAttribute('stroke', 'none');
        svg.appendChild(dot);
      });
    }
    if (kind === 'delete') {
      /* a bin: lid, body, two slats */
      svg.removeChild(frame); svg.removeChild(a); svg.removeChild(c);
      var lid = d.createElementNS(ns, 'path');
      lid.setAttribute('d', 'M2.5 4.5h13M6.5 4.5V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1.5');
      var body = d.createElementNS(ns, 'path');
      body.setAttribute('d', 'M4 4.5l.8 10.2a1.3 1.3 0 0 0 1.3 1.3h5.8a1.3 1.3 0 0 0 1.3-1.3L14 4.5M7.3 7.5v5.5M10.7 7.5v5.5');
      svg.appendChild(lid); svg.appendChild(body);
    }
    var t = d.createElement('span');
    t.textContent = label;
    b.appendChild(svg);
    b.appendChild(t);
    return b;
  }

  /* Asked for: the "Our Product" panel shows only the piece the visitor chose
     on the website. The plug-in passes that piece in when it opens the tool
     (the preview takes it from ?piece=). With no piece named, the panel shows
     everything except the pieces removed at the shop's request. */
  var REMOVE_PRODUCTS = [/^chef knife/i];
  var soloName = null;
  function solo(name) {
    soloName = name ? String(name).replace(/\s+/g, ' ').trim().toLowerCase() : null;
  }
  function hideProducts(d) {
    var all = d.querySelectorAll('button');
    var cards = [];
    for (var i = 0; i < all.length; i++) {
      var b = all[i], t = (b.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/\$\d/.test(t) || t.length > 90 || /quote|cart|checkout/i.test(t)) continue;
      var card = (b.closest && b.closest('li, [role="listitem"]')) || b;
      var hide = REMOVE_PRODUCTS.some(function (re) { return re.test(t); });
      if (soloName) hide = t.toLowerCase().indexOf(soloName) < 0;
      cards.push({ card: card, hide: hide });
    }
    /* a name that matches nothing must not empty the panel */
    if (soloName && !cards.some(function (c) { return !c.hide; })) {
      cards.forEach(function (c) { c.hide = false; });
    }
    cards.forEach(function (c) {
      if (c.hide) {
        c.card.style.display = 'none';
        c.card.setAttribute('data-acp-removed', 'product');
      } else if (c.card.getAttribute('data-acp-removed') === 'product') {
        c.card.style.display = '';
        c.card.removeAttribute('data-acp-removed');
      }
    });
  }

  /* Asked for: the upload button reads "Upload your product" with an upload
     arrow instead of the ▲ glyph. */
  function relabelUpload(d) {
    var labels = d.querySelectorAll('label');
    for (var i = 0; i < labels.length; i++) {
      var l = labels[i];
      if (l.__acpRelabelled || !l.querySelector('input[type="file"]')) continue;
      if (!/upload from computer/i.test(l.textContent)) continue;
      l.__acpRelabelled = true;
      for (var n = l.firstChild; n; n = n.nextSibling) {
        if (n.nodeType === 3 && /upload from computer/i.test(n.nodeValue)) n.nodeValue = ' Upload your product ';
      }
      var glyph = l.querySelector('span');
      if (glyph && /\u25B2/.test(glyph.textContent)) {
        glyph.textContent = '';
        glyph.style.display = 'flex';
        var ns = 'http://www.w3.org/2000/svg';
        var svg = d.createElementNS(ns, 'svg');
        svg.setAttribute('width', '18'); svg.setAttribute('height', '18');
        svg.setAttribute('viewBox', '0 0 18 18'); svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '1.6');
        svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round');
        svg.setAttribute('aria-hidden', 'true');
        var p = d.createElementNS(ns, 'path');
        /* arrow up out of a tray */
        p.setAttribute('d', 'M9 12V3M5.5 6.5L9 3l3.5 3.5M3 11.5v2.5a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-2.5');
        svg.appendChild(p);
        glyph.appendChild(svg);
      }
    }
  }

  /* ---------- faster background removal ----------
     "Remove BG" first tries an AI cut-out: on the first click that means
     downloading a large model over the network (tens of MB), so the visitor
     waits a long time on "Loading AI…" with the piece locked. From outside:
     1. the moment an image is uploaded, the AI is fetched in the background,
        so it is usually cached by the time anyone asks for it;
     2. the click itself returns the tool's quick pixel cut-out straight away
        (the AI gets a few seconds only when it is already warm), so the piece
        is ready to drag and size immediately;
     3. when the AI finishes later it quietly replaces the quick cut-out with
        the better one — unless the visitor has restored the background. */
  var IMGLY = 'https://esm.run/@imgly/background-removal@1.5.8';
  function logicOf(d) {
    var el = d.querySelector('button') || d.body.firstElementChild;
    if (!el) return null;
    var key = Object.keys(el).filter(function (k) { return k.indexOf('__reactFiber') === 0; })[0];
    var f = el[key];
    while (f && !(f.stateNode && f.stateNode.logic && typeof f.stateNode.logic.removeBg === 'function')) f = f.return;
    return f ? f.stateNode.logic : null;
  }
  function warmAi(d, L) {
    if (L.__acpWarming) return;
    L.__acpWarming = true;
    var w = d.defaultView;
    var load = L._imgly ? Promise.resolve(L._imgly) : w.eval('import(' + JSON.stringify(IMGLY) + ')');
    load.then(function (mod) {
      L._imgly = mod;
      var fn = mod.removeBackground || (mod.default && mod.default.removeBackground);
      if (!fn) return;
      /* one run on a blank dot pulls the model into the browser cache */
      var c = d.createElement('canvas'); c.width = 8; c.height = 8;
      c.getContext('2d').fillRect(2, 2, 4, 4);
      return new Promise(function (res) { c.toBlob(res, 'image/png'); })
        .then(function (blob) { return fn(blob, { output: { format: 'image/png' } }); })
        .then(function () { L.__acpWarm = true; });
    }).catch(function () { L.__acpWarming = false; });
  }
  /* the tool's own quick cut-out, word for word, run off the main thread so
     the page (and the battery) keep moving while it works */
  var CUT_WORKER = "self.onmessage=function(ev){var w=ev.data.w,h=ev.data.h,d=new Uint8ClampedArray(ev.data.buf);"
    + "var ring=[],depth=Math.max(2,Math.round(Math.min(w,h)*0.012)),k,x,y,i,p;"
    + "for(k=0;k<depth;k++){for(x=k;x<w-k;x+=2){ring.push((k*w+x)*4);ring.push(((h-1-k)*w+x)*4);}for(y=k;y<h-k;y+=2){ring.push((y*w+k)*4);ring.push((y*w+(w-1-k))*4);}}"
    + "var bins={};for(i=0;i<ring.length;i++){p=ring[i];var key=((d[p]>>4)<<8)|((d[p+1]>>4)<<4)|(d[p+2]>>4);var b=bins[key]||(bins[key]={n:0,r:0,g:0,b:0});b.n++;b.r+=d[p];b.g+=d[p+1];b.b+=d[p+2];}"
    + "var clusters=Object.keys(bins).map(function(k){return bins[k]}).filter(function(b){return b.n/ring.length>=0.04}).sort(function(a,b){return b.n-a.n}).slice(0,5).map(function(b){return[b.r/b.n,b.g/b.n,b.b/b.n]});"
    + "if(!clusters.length){var r=0,g=0,bb=0;for(i=0;i<ring.length;i++){p=ring[i];r+=d[p];g+=d[p+1];bb+=d[p+2];}clusters.push([r/ring.length,g/ring.length,bb/ring.length]);}"
    + "function dist(p){var i=p*4,best=1e9;for(var c=0;c<clusters.length;c++){var cl=clusters[c],dr=d[i]-cl[0],dg=d[i+1]-cl[1],db=d[i+2]-cl[2],v=dr*dr*0.9+dg*dg*1.2+db*db*0.9;if(v<best)best=v;}return Math.sqrt(best);}"
    + "var spread=0;for(i=0;i<ring.length;i++)spread+=dist(ring[i]/4);spread/=ring.length;"
    + "var tol=Math.max(38,Math.min(105,34+spread*2.4)),feather=tol*2.1;"
    + "var seen=new Uint8Array(w*h),q=new Int32Array(w*h),qs=0,qe=0;"
    + "function seed(p){if(!seen[p]&&dist(p)<tol){seen[p]=1;q[qe++]=p;}}"
    + "for(x=0;x<w;x++){seed(x);seed((h-1)*w+x);}for(y=0;y<h;y++){seed(y*w);seed(y*w+w-1);}"
    + "self.postMessage({pct:30});"
    + "while(qs<qe){p=q[qs++];d[p*4+3]=0;x=p%w;y=(p-x)/w;if(x>0)seed(p-1);if(x<w-1)seed(p+1);if(y>0)seed(p-w);if(y<h-1)seed(p+w);if(x>0&&y>0)seed(p-w-1);if(x<w-1&&y>0)seed(p-w+1);if(x>0&&y<h-1)seed(p+w-1);if(x<w-1&&y<h-1)seed(p+w+1);}"
    + "self.postMessage({pct:70});"
    + "var alpha0=new Uint8Array(w*h);for(p=0;p<w*h;p++)alpha0[p]=d[p*4+3];"
    + "for(y=1;y<h-1;y++){for(x=1;x<w-1;x++){p=y*w+x;if(!alpha0[p])continue;var open=0;if(!alpha0[p-1])open++;if(!alpha0[p+1])open++;if(!alpha0[p-w])open++;if(!alpha0[p+w])open++;if(!alpha0[p-w-1])open++;if(!alpha0[p-w+1])open++;if(!alpha0[p+w-1])open++;if(!alpha0[p+w+1])open++;if(!open)continue;var dd=dist(p);if(open>=6&&dd<feather){d[p*4+3]=0;continue;}if(dd<feather){var t=(dd-tol)/(feather-tol);d[p*4+3]=Math.max(0,Math.min(255,Math.round(t*255)));}}}"
    + "self.postMessage({buf:d.buffer},[d.buffer]);};";
  var cutWorkerUrl = null;
  function cutInWorker(d, buf, w, h, onPct) {
    var win = d.defaultView;
    return new Promise(function (res, rej) {
      if (!cutWorkerUrl) cutWorkerUrl = win.URL.createObjectURL(new win.Blob([CUT_WORKER], { type: 'text/javascript' }));
      var wk = new win.Worker(cutWorkerUrl);
      wk.onmessage = function (ev) {
        if (ev.data && ev.data.pct != null) { onPct && onPct(ev.data.pct); return; }
        wk.terminate(); res(ev.data.buf);
      };
      wk.onerror = function (e) { wk.terminate(); rej(e); };
      wk.postMessage({ buf: buf, w: w, h: h }, [buf]);
    });
  }
  function fastBg(d) {
    var L = logicOf(d);
    if (!L || L.__acpFast) return;
    L.__acpFast = true;
    /* Asked for: Remove BG faster. The click now goes straight to the quick
       cut-out (never waits on the AI first), the cut-out runs in a worker so
       the page never freezes, and the AI pass starts only after the quick
       result is on screen — swapping in quietly when done. */
    var origRemove = L.removeBg.bind(L);
    L.removeBg = function () {
      var st = L.state;
      var el = st.els.filter(function (x) { return st.sel.indexOf(x.id) > -1; }).slice(-1)[0];
      if (!el || el.type !== 'image' || st.bgBusy) return;
      if (el.bgRemoved) { L.patchById(el.id, { src: el.origSrc, bgRemoved: false, bgMode: null }); return; }
      var src = el.origSrc || el.src, id = el.id, win = d.defaultView;
      if (!win.Worker) return origRemove();
      L.setState({ bgBusy: true, bgStage: 'Removing\u2026' });
      bgPct = Math.max(bgPct, 6);
      return L.loadImg(src).then(function (img) {
        bgPct = Math.max(bgPct, 12);
        var scale = Math.min(1, 1400 / Math.max(img.width, img.height));
        var w = Math.max(1, Math.round(img.width * scale)), h = Math.max(1, Math.round(img.height * scale));
        var c = d.createElement('canvas'); c.width = w; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, w, h);
        var idata = ctx.getImageData(0, 0, w, h);
        return cutInWorker(d, idata.data.buffer, w, h, function (p) { bgPct = Math.max(bgPct, p); }).then(function (buf) {
          bgPct = 100;
          ctx.putImageData(new win.ImageData(new win.Uint8ClampedArray(buf), w, h), 0, 0);
          L.patchById(id, { src: c.toDataURL('image/png'), bgRemoved: true, bgMode: 'pixel' });
          L.setState({ bgBusy: false, bgStage: '' });
          /* the better AI cut-out follows once the quick one is on screen */
          setTimeout(function () { try { var r = L.aiCutout(src); if (r && r.catch) r.catch(function () {}); } catch (e) {} }, 300);
        });
      }).catch(function (e) {
        console.warn('quick cut-out (worker) failed, using the tool\u2019s own', e);
        L.setState({ bgBusy: false, bgStage: '' });
        return origRemove();
      });
    };
    var origAi = L.aiCutout.bind(L);
    L.aiCutout = function (src) {
      var st = L.state;
      var el = st.els.filter(function (x) { return st.sel.indexOf(x.id) > -1; }).slice(-1)[0];
      var id = el && el.id;
      var ai = origAi(src);
      ai.then(function (url) {
        L.__acpWarm = true;
        if (!url || !id) return;
        /* swap in the better cut-out if the quick one is still what is shown */
        var now = L.state.els.filter(function (x) { return x.id === id; })[0];
        if (now && now.bgRemoved && now.bgMode === 'pixel' && (now.origSrc || src) === src) {
          L.patchById(id, { src: url, bgMode: 'ai' });
        }
      }).catch(function () {});
      var budget = 0;
      return Promise.race([ai, new Promise(function (_, rej) {
        setTimeout(function () { rej(new Error('quick cut-out first')); }, budget);
      })]);
    };
    if (typeof L.onFilesPicked === 'function') {
      var origPick = L.onFilesPicked.bind(L);
      L.onFilesPicked = function () { warmAi(d, L); return origPick.apply(L, arguments); };
    }
    /* an image already on the piece means the AI may be wanted soon */
    if (d.querySelector('[style*="cursor: move"] img')) warmAi(d, L);
  }

  /* ---------- one toolbar ----------
     Asked for: the text toolbar and the image toolbar combined into a single
     section instead of swapping places depending on what is selected. The
     tool shows one or the other; from outside both are asked for whenever a
     piece is selected, the two cards are joined into one, the shared cluster
     (Duplicate / Group / Delete / Undo) appears once, and the controls that
     do not apply to the selected piece are dimmed rather than hidden. */
  function unifyBars(d) {
    var L = logicOf(d);
    if (L && !L.__acpUnified && typeof L.renderVals === 'function') {
      L.__acpUnified = true;
      /* asked for: icons that render in colour (emoji-style) are kept out of
         the Icons library; everything stays black and white */
      var COLOUR_GLYPHS = ['\u270C', '\u270D', '\u26A1'];
      var origSets = L.catSets.bind(L);
      L.catSets = function () {
        var s = origSets.apply(L, arguments) || {};
        var out = {};
        Object.keys(s).forEach(function (k) { out[k] = s[k].filter(function (ch) { return COLOUR_GLYPHS.indexOf(ch) === -1; }); });
        return out;
      };
      var orig = L.renderVals.bind(L);
      L.renderVals = function () {
        var v = orig.apply(L, arguments) || {};
        /* asked for: the toolbar stays up all the time in the Design step,
           even with nothing selected (a click on an empty safe area) */
        if (v.imgSelOpen || v.textSelOpen || L.state.step === 'Design') { v.imgSelOpen = true; v.textSelOpen = true; }
        return v;
      };
      try { L.forceUpdate(); } catch (e) {}
    }
    var bars = [].filter.call(d.querySelectorAll('[style*="border-radius: 16px"]'), function (b) {
      return b.querySelector('button[title^="Duplicate"]');
    });
    if (!bars.length) return;
    var sel = selectedWrapper(d);
    var isImage = !!(sel && sel.querySelector('img'));
    var none = !sel;
    var isArt = false;
    try { var Ls = logicOf(d); var act = Ls && Ls.state.els.filter(function (x) { return Ls.state.sel.indexOf(x.id) > -1; }).slice(-1)[0]; isArt = !!(act && act.type === 'image' && act.kind !== 'product'); } catch (e) {}
    bars.forEach(function (bar) {
      var text = !!bar.querySelector('input[type="file"], label') || /edit text/i.test(bar.textContent);
      bar.setAttribute('data-acp-bar', text ? 'text' : 'image');
      var kids = [].slice.call(bar.children);
      var dupBox = bar.querySelector('button[title^="Duplicate"]').parentElement;
      var undo = bar.querySelector('button[title^="Undo"]');
      var undoBox = undo && undo.parentElement;
      var isDivider = function (k) { return /width: 1px/.test(k.getAttribute('style') || ''); };
      kids.forEach(function (k, i) {
        var shared = k === dupBox || k === undoBox
          || (isDivider(k) && (kids[i + 1] === dupBox || kids[i + 1] === undoBox));
        if (!text) {
          /* the image bar's copy of the shared cluster is not needed twice */
          if (shared) { k.style.display = 'none'; k.setAttribute('data-acp-removed', 'dup-cluster'); return; }
        }
        var off = shared ? false : (text ? isImage : !isImage);
        if (none && !shared) off = true;
        if (k.getAttribute('data-acp-btn') === 'addtext' || k.getAttribute('data-acp-btn') === 'upload' || k.getAttribute('data-acp-btn') === 'upload-wrap' || k.getAttribute('data-acp-btn') === 'upload-div' || k.getAttribute('data-acp-btn') === 'arrange-group') off = false;
        /* colours stay live for a logo / upload: they recolour it */
        if (isArt && k.querySelector && k.querySelector('button[title="Text colour"]')) off = false;
        if (k.getAttribute('data-acp-removed') === 'button' || k.getAttribute('data-acp-removed') === 'product') return;
        k.style.opacity = off ? '.35' : '';
        k.style.pointerEvents = off ? 'none' : '';
      });
    });
  }

  /* Asked for: adding text moves out of the side panel and into the toolbar,
     next to Edit text. The panel's own "type here" field and "Add a text box"
     button are hidden; the new toolbar button presses the hidden one, so the
     tool itself does the adding exactly as before. */
  function addTextButton(d) {
    var hidden = findAddBox(d);
    if (hidden) {
      var field = hidden.parentElement && hidden.parentElement.querySelector('input');
      if (field && !field.closest('[style*="cursor: move"]')) {
        field.style.display = 'none';
        field.setAttribute('data-acp-removed', 'text-field');
      }
    }
    var edits = [].filter.call(d.querySelectorAll('button'), function (b) {
      return /^edit text$/i.test((b.textContent || '').trim());
    });
    edits.forEach(function (edit) {
      if (edit.nextElementSibling && edit.nextElementSibling.getAttribute('data-acp-btn') === 'addtext') return;
      var b = d.createElement('button');
      b.type = 'button';
      b.setAttribute('data-acp-btn', 'addtext');
      b.setAttribute('style', edit.getAttribute('style') || '');
      b.textContent = 'Add text';
      b.title = 'Add a text box';
      edit.insertAdjacentElement('afterend', b);
    });
  }

  /* ---------- side thumbnails ----------
     Asked for: the Front / Back thumbnails beside the piece show the chosen
     product's 1st and 2nd store photos instead of a text preview. The tool
     only keeps each product's first photo, so the catalogue is read once
     here and the two photos are laid over the tool's own preview boxes. */
  var catalog = null, catalogBusy = false;
  function loadCatalog(d, L) {
    if (catalog || catalogBusy) return;
    catalogBusy = true;
    var base = '';
    try { base = L.shopBase(); } catch (e) {}
    d.defaultView.fetch(base + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var c = {};
        (data.products || []).forEach(function (p) {
          var im = (p.images || []).map(function (x) { return x.src; }).filter(Boolean);
          c[String(p.title).toLowerCase()] = im;
          c[String(p.handle).toLowerCase()] = im;
        });
        catalog = c;
        try { sideThumbs(d); } catch (e) {}
      })
      .catch(function () { setTimeout(function () { catalogBusy = false; }, 4000); });
  }
  function chosenTitle(d, L) {
    if (L.state.shopPick && L.state.shopPick.title) return L.state.shopPick.title;
    if (soloName) return soloName;
    var cards = [].filter.call(d.querySelectorAll('button'), function (b) {
      var t = (b.textContent || '').trim();
      return /\$\d/.test(t) && t.length < 90 && b.style.display !== 'none' && b.querySelector('img');
    });
    if (cards.length !== 1) return null;
    var name = cards[0].querySelector('span span');
    return name ? name.textContent.trim() : null;
  }
  function thumb(src) {
    if (!src) return '';
    if (/^data:|^blob:/.test(src)) return src;
    return String(src).replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2');
  }
  /* the photos to show for the piece: the visitor's own upload when Your
     Product is the source, otherwise the store product's photos */
  function productPhotos(d, L) {
    var yours = L.state.els.filter(function (e) { return e.kind === 'product' && e.source === 'yours'; });
    if (ws === 'yours' || yours.length) {
      /* Your Product: only the visitor's own uploads, never the store photos */
      /* one photo per side, in side order; a side with nothing placed yet
         shows the tray picture that belongs to it */
      var out = [], any = false;
      yours.forEach(function (e) { var i = sideIndex(e.side || 'front'); if (!out[i]) { out[i] = e.origSrc || e.src; any = true; } });
      if (ws === 'yours') yourTray(L).forEach(function (u, i) { if (!out[i] && u && u.src) { out[i] = u.src; any = true; } });
      for (var k = 0; k < out.length; k++) if (!out[k]) out[k] = '';
      return any ? out : null;
    }
    var title = chosenTitle(d, L);
    var key = title && String(title).toLowerCase();
    return catalog && key && (catalog[key] || Object.keys(catalog).filter(function (k) { return k.indexOf(key) > -1; }).map(function (k) { return catalog[k]; })[0]) || null;
  }
  function sideThumbs(d) {
    var L = logicOf(d);
    if (!L) return;
    loadCatalog(d, L);
    var btns = [].filter.call(d.querySelectorAll('button[style*="width: 86px"]'), function (b) {
      return isSideBtn(b);
    });
    if (!btns.length) return;
    var imgs = productPhotos(d, L);
    btns.forEach(function (b) {
      var box = b.firstElementChild;
      var text = box && box.querySelector('.sc-interp');
      var img = box && box.querySelector('img[data-acp-thumb]');
      var src = imgs ? thumb(imgs[sideIndex(sideIdOf(b))]) : '';
      if (!box) return;
      if (!src) {
        if (img) img.remove();
        if (text) text.style.display = '';
        return;
      }
      if (!img) {
        img = d.createElement('img');
        img.setAttribute('data-acp-thumb', '');
        img.alt = '';
        img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
        box.style.padding = '0';
        box.appendChild(img);
      }
      if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      if (text) text.style.display = 'none';
    });
  }

  /* Asked for: the Front / Back thumbnails do not switch to another side of
     the design — there is one design. Clicking one shows that product photo in
     the safe area (1st photo for Front, 2nd for Back) under whatever is
     already placed. The tool's own side switch is stopped before it runs. */
  var face = 0;
  /* the side thumbnails keep their real name (Front / Back) in an attribute;
     what they show is the number (see numberSides) */
  function sideName(b) { return b.getAttribute('data-acp-sidename') || (b.textContent || '').trim(); }
  function isSideBtn(b) { return b.hasAttribute('data-acp-sideid') || /(Front|Back)$/.test(sideName(b)); }
  /* sides beyond the tool's two: the 1st is front, the 2nd back, then side3… */
  function sideIdAt(i) { return i === 0 ? 'front' : i === 1 ? 'back' : 'side' + (i + 1); }
  function sideIndex(id) { id = id || 'front'; return id === 'front' ? 0 : id === 'back' ? 1 : (parseInt(String(id).replace(/^side/, ''), 10) || 1) - 1; }
  function sideIdOf(b) { return b.getAttribute('data-acp-sideid') || (/Back$/.test(sideName(b)) ? 'back' : 'front'); }
  function sideLabel(id) { var i = sideIndex(id); return i === 0 ? 'Front' : i === 1 ? 'Back' : 'Side ' + (i + 1); }
  /* Your Product's tray: the visitor's pieces (toolbar files live elsewhere) */
  function yourTray(L) { return ((L && L.state.uploads) || []).filter(function (u) { return !(u && u.acpOrigin === 'file'); }); }
  /* Asked for: the two side thumbnails read 1 and 2 instead of Front and Back */
  function numberSides(d) {
    [].forEach.call(d.querySelectorAll('button[style*="width: 86px"]'), function (b, i) {
      var lab = b.lastElementChild;
      if (!lab || lab.tagName !== 'SPAN') return;
      var t = (lab.textContent || '').trim();
      if (/^(Front|Back)$/.test(t)) { b.setAttribute('data-acp-sidename', t); lab.textContent = t === 'Front' ? '1' : '2'; }
      if (/^(Front|Back|\d+)$/.test(t)) b.setAttribute('data-acp-sideid', sideIdAt(i));
    });
  }
  function sideButtons(d) {
    return [].filter.call(d.querySelectorAll('button[style*="width: 86px"]'), function (b) {
      return isSideBtn(b);
    });
  }
  function showFace(d, L, which) {
    /* Your Product with two uploads: the sides are separate pieces, so the
       thumbnail switches side instead of swapping the photo */
    if (twoSides(L) && mode !== 'both') {
      L.setState({ side: sideIdAt(which), sel: [], editingId: null });
      face = which;
      return;
    }
    var imgs = productPhotos(d, L);
    if (!imgs || !imgs[which]) return;
    face = which;
    var src = imgs[which];
    L.loadImg(src).then(function (im) { return im.width / im.height; }, function () { return 1; }).then(function (aspect) {
      try { L.snap(); } catch (e) {}
      L.setState(function (st) {
        var side = st.side || 'front';
        var cur = st.els.filter(function (e) { return e.kind === 'product' && (e.side || 'front') === side; }).slice(-1)[0];
        if (cur) {
          return { els: st.els.map(function (e) {
            return e === cur ? Object.assign({}, e, { src: src, origSrc: src, aspect: aspect, bgRemoved: false }) : e;
          }) };
        }
        return {
          els: st.els.concat([{ id: st.nextId, side: side, type: 'image', kind: 'product', source: 'ours',
            src: src, origSrc: src, aspect: aspect, left: 50, top: 50, w: 100, bgRemoved: false }]),
          nextId: st.nextId + 1
        };
      });
    });
  }
  /* the thumbnails switch real sides (two separate designs) when Both sides is
     chosen, and always in Your Product, where each upload is its own piece */
  function twoSides(L) {
    if (mode === 'both' || ws === 'yours') return true;
    if (!L) return false;
    return L.state.els.some(function (e) { return e.kind === 'product' && e.source === 'yours'; });
  }
  function markFaces(d) {
    var L = logicOf(d);
    var two = twoSides(L);
    var cur = (two && L) ? sideIndex(L.state.side) : face;
    sideButtons(d).forEach(function (b, i) {
      /* Both: both thumbnails are chosen; the one being worked on is marked */
      b.setAttribute('data-acp-face', (mode === 'both' || i === cur) ? 'on' : 'off');
      b.setAttribute('data-acp-current', i === cur ? 'on' : 'off');
    });
  }

  /* Asked for: the thumbnail of the photo that is showing is a live preview of
     the design — the product photo plus everything placed on it, exactly as it
     sits in the safe area. A scaled copy of the stage is laid into that
     thumbnail and refreshed whenever the stage changes; the selection frame,
     handles, mini toolbar and safe-area guide are left out. The other
     thumbnail keeps its plain store photo. */
  var lastStage = '', lastFace = -1;
  function liveThumb(d) {
    var safe = d.querySelector('[style*="dashed"]');
    var stage = safe && safe.parentElement;
    var btns = sideButtons(d);
    if (!stage || !btns.length) return;
    var Lf = logicOf(d);
    var active = twoSides(Lf) ? sideIndex(Lf.state.side) : face;
    if (active !== lastFace) { lastFace = active; lastStage = ''; }
    btns.forEach(function (b, i) {
      try { liveOne(d, stage, b, i, active); } catch (e) { d.__acpErr = String(e && e.stack || e); }
    });
  }
  function liveOne(d, stage, b, i, active) {
    {
      var box = b.firstElementChild;
      if (!box) return;
      var live = box.querySelector('[data-acp-live]');
      var img = box.querySelector('img[data-acp-thumb]');
      if (i !== active) {
        if (live) live.remove();
        if (img) img.style.display = '';
        return;
      }
      if (img) img.style.display = 'none';
      var html = stage.innerHTML;
      if (live && html === lastStage) return;
      lastStage = html;
      if (!live) {
        live = d.createElement('div');
        live.setAttribute('data-acp-live', '');
        live.style.cssText = 'position:absolute;inset:0;overflow:hidden;pointer-events:none;';
        box.style.position = 'relative';
        box.style.padding = '0';
        box.appendChild(live);
      }
      var r = stage.getBoundingClientRect(), W = r.width || 420, H = r.height || 420;
      var bw = box.clientWidth || 86, bh = box.clientHeight || 58;
      /* fit the photo (the piece itself), not the whole stage with its margins,
         so the tile is filled edge to edge and reads at a glance */
      var pic = stage.querySelector('img');
      var pr = pic ? pic.getBoundingClientRect() : r;
      var k = Math.min(bw / (pr.width || W), bh / (pr.height || H));
      var ox = (bw - W * k) / 2 - (pr.left - r.left + pr.width / 2 - W / 2) * k;
      var oy = (bh - H * k) / 2 - (pr.top - r.top + pr.height / 2 - H / 2) * k;
      box.style.background = 'rgb(226, 229, 233)';
      var clone = stage.cloneNode(true);
      clone.removeAttribute('data-dc-tpl');
      clone.style.cssText += ';position:absolute;left:' + ox + 'px;top:' + oy + 'px;'
        + 'width:' + W + 'px;height:' + H + 'px;transform:scale(' + k + ');transform-origin:0 0;'
        + 'border-radius:0;box-shadow:none;aspect-ratio:auto;max-height:none;background:transparent;';
      /* strip editing chrome */
      [].forEach.call(clone.querySelectorAll('*'), function (el) {
        var s = el.getAttribute('style') || '';
        if (s.indexOf('rgb(255, 45, 155)') > -1 || s.indexOf('calc(100% + 1') > -1
            || (s.indexOf('dashed') > -1 && s.indexOf('inset:') > -1 && el !== clone)) {
          if (s.indexOf('dashed') > -1) { el.style.border = 'none'; }
          else el.style.display = 'none';
        }
        if (el.tagName === 'TEXTAREA') {
          var t = d.createElement('div');
          t.setAttribute('style', s + ';white-space:pre;');
          t.textContent = el.value;
          el.parentNode.replaceChild(t, el);
        }
      });
      var tag = clone.querySelector('[style*="Safe area"], span[style*="top: -11px"]');
      if (tag) tag.style.display = 'none';
      [].forEach.call(clone.querySelectorAll('[data-acp-sel],[data-acp-group]'), function (el) { el.style.outline = 'none'; });
      live.innerHTML = '';
      live.appendChild(clone);
    }
  }

  /* the product is placed the moment the panel shows it, so the design opens
     on the piece with nothing to pick: the named piece when the visitor came
     from one, otherwise the only piece the panel offers */
  function autoPick(d, L) {
    if (L.__acpPicked || L.state.shopPick) return;
    var cards = [].filter.call(d.querySelectorAll('button'), function (b) {
      var t = (b.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      return /\$\d/.test(t) && t.length < 90 && b.style.display !== 'none' && b.querySelector('img');
    });
    var card = soloName
      ? cards.filter(function (b) { return (b.textContent || '').toLowerCase().indexOf(soloName) > -1; })[0]
      : (cards.length === 1 ? cards[0] : null);
    if (!card) return;
    L.__acpPicked = true;
    card.click();
  }

  /* Asked for: an "Upload your file" button in the image row of the toolbar,
     after Effects. It is the same file picker as the Your Product panel's
     upload, opened from the toolbar. */
  /* Asked for: an arrangement toolbar like LightBurn's, open all the time, for
     Our Product and Your Product alike. Only what the LightBurn Arrangement
     toolbar has: Group, Ungroup; Mirror vertical, Mirror horizontal; Align
     centers; Align left / centre / right; Align top / middle / bottom;
     Distribute vertically (centres, gaps); Distribute horizontally (centres,
     gaps). Icons follow LightBurn's. Mirror-across-a-line needs a drawn line,
     which the customizer has none of, so it is left out. */
  var ARR_ICON = {
    group: '<circle cx="7" cy="6.5" r="2.6"/><path d="M2.5 15.5c0-2.8 2-4.5 4.5-4.5s4.5 1.7 4.5 4.5"/><circle cx="13.5" cy="6" r="2.3"/><path d="M12.2 10.6c2.9-.4 5.3 1.5 5.3 4.4"/>',
    ungroup: '<circle cx="10" cy="6.5" r="3"/><path d="M4.5 16.5c0-3.3 2.4-5.3 5.5-5.3s5.5 2 5.5 5.3"/>',
    mirrorV: '<path d="M2.5 10h15" stroke-dasharray="2 1.5"/><path d="M5 8V3l10 5z" fill="currentColor"/><path d="M5 12v5l10-5z"/>',
    mirrorH: '<path d="M10 2.5v15" stroke-dasharray="2 1.5"/><path d="M8 5H3l5 10z" fill="currentColor"/><path d="M12 5h5l-5 10z"/>',
    centers: '<circle cx="10" cy="10" r="5.5"/><circle cx="10" cy="10" r="1.4" fill="currentColor"/><path d="M10 1.5v3M10 15.5v3M1.5 10h3M15.5 10h3"/>',
    left: '<path d="M3.5 2.5v15"/><rect x="5.5" y="4.5" width="11" height="4" rx=".8"/><rect x="5.5" y="11.5" width="6.5" height="4" rx=".8"/>',
    centerX: '<path d="M10 2.5v15" stroke-dasharray="2 1.5"/><rect x="4" y="4.5" width="12" height="4" rx=".8"/><rect x="6.5" y="11.5" width="7" height="4" rx=".8"/>',
    right: '<path d="M16.5 2.5v15"/><rect x="3.5" y="4.5" width="11" height="4" rx=".8"/><rect x="8" y="11.5" width="6.5" height="4" rx=".8"/>',
    top: '<path d="M2.5 3.5h15"/><rect x="4.5" y="5.5" width="4" height="11" rx=".8"/><rect x="11.5" y="5.5" width="4" height="6.5" rx=".8"/>',
    middleY: '<path d="M2.5 10h15" stroke-dasharray="2 1.5"/><rect x="4.5" y="4" width="4" height="12" rx=".8"/><rect x="11.5" y="6.5" width="4" height="7" rx=".8"/>',
    bottom: '<path d="M2.5 16.5h15"/><rect x="4.5" y="3.5" width="4" height="11" rx=".8"/><rect x="11.5" y="8" width="4" height="6.5" rx=".8"/>',
    distVC: '<path d="M10 2v16" stroke-dasharray="2 1.5"/><rect x="5" y="3" width="10" height="3" rx=".8"/><rect x="5" y="8.5" width="10" height="3" rx=".8"/><rect x="5" y="14" width="10" height="3" rx=".8"/>',
    distVE: '<path d="M2.5 2.5h15M2.5 17.5h15"/><rect x="5" y="4.5" width="10" height="3" rx=".8"/><rect x="5" y="9.5" width="10" height="1.6" rx=".6"/><rect x="5" y="13" width="10" height="3" rx=".8"/>',
    distHC: '<path d="M2 10h16" stroke-dasharray="2 1.5"/><rect x="3" y="5" width="3" height="10" rx=".8"/><rect x="8.5" y="5" width="3" height="10" rx=".8"/><rect x="14" y="5" width="3" height="10" rx=".8"/>',
    distHE: '<path d="M2.5 2.5v15M17.5 2.5v15"/><rect x="4.5" y="5" width="3" height="10" rx=".8"/><rect x="9.5" y="5" width="1.6" height="10" rx=".6"/><rect x="13" y="5" width="3" height="10" rx=".8"/>'
  };
  var ARR_ITEMS = [
    ['group', 'group', 'Group'], ['ungroup', 'ungroup', 'Ungroup'], null,
    ['arr', 'mirrorV', 'Vertical mirror (Ctrl+Shift+V, or V)'], ['arr', 'mirrorH', 'Horizontal mirror (Ctrl+Shift+H, or H)'], null,
    ['arr', 'centers', 'Align centers'], ['arr', 'left', 'Align left'], ['arr', 'centerX', 'Align vertical centers'], ['arr', 'right', 'Align right'], null,
    ['arr', 'top', 'Align top'], ['arr', 'middleY', 'Align horizontal centers'], ['arr', 'bottom', 'Align bottom']
  ];
  function arrangeBar(d) {
    var L = logicOf(d);
    var img = d.querySelector('[data-acp-bar="image"]');
    var col = img && img.parentElement;
    var bar = d.querySelector('[data-acp-arrange]');
    if (!col) { if (bar) bar.style.display = 'none'; return; }
    if (!bar) {
      bar = d.createElement('div');
      bar.setAttribute('data-acp-arrange', '');
      bar.setAttribute('data-acp-btn', 'arrange-group');
      /* asked for: sits inside the image toolbar so everything is together */
      bar.setAttribute('style', 'flex: 0 0 auto; display: flex; align-items: center; gap: 2px;');
      ARR_ITEMS.forEach(function (it) {
        if (!it) {
          var dv = d.createElement('span');
          dv.setAttribute('style', 'width: 1px; height: 22px; background: rgb(229, 231, 235); margin: 0 5px; flex: 0 0 1px;');
          bar.appendChild(dv);
          return;
        }
        var b = d.createElement('button');
        b.type = 'button';
        b.setAttribute('data-acp-btn', it[0]);
        b.setAttribute('data-acp-arr', it[1]);
        b.title = it[2];
        b.setAttribute('aria-label', it[2]);
        b.setAttribute('style', 'width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; border: 0; border-radius: 7px;'
          + 'background: transparent; color: rgb(75, 85, 99); cursor: pointer; padding: 0; flex: 0 0 30px;');
        b.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ARR_ICON[it[1]] + '</svg>';
        b.addEventListener('mouseenter', function () { if (!b.__acpOn) b.style.background = 'rgb(243, 244, 246)'; });
        b.addEventListener('mouseleave', function () { if (!b.__acpOn) b.style.background = 'transparent'; });
        bar.appendChild(b);
      });
      var tail = d.createElement('span');
      tail.setAttribute('data-acp-btn', 'arrange-div');
      tail.setAttribute('style', 'width: 1px; height: 28px; background: rgb(229, 231, 235); margin: 0 4px; flex: 0 0 1px;');
      bar.appendChild(tail);
    }
    if (bar.parentElement !== img) img.insertBefore(bar, img.firstChild);
    bar.style.display = (L && L.state.step === 'Design') ? 'flex' : 'none';
    var gb = bar.querySelector('[data-acp-arr="group"]');
    if (gb) {
      gb.__acpOn = picking;
      gb.style.background = picking ? 'rgb(17, 24, 39)' : (gb.matches(':hover') ? 'rgb(243, 244, 246)' : 'transparent');
      gb.style.color = picking ? 'rgb(255, 255, 255)' : 'rgb(75, 85, 99)';
      var live = pending.filter(function (w) { return w.isConnected; }).length;
      gb.title = picking ? (live > 1 ? 'Group the ' + live + ' chosen pieces' : 'Click pieces to choose them, then click again to group') : 'Group';
    }
  }
  /* mirror: the tool's flip swaps positions across the selection; a single
     piece also needs its own picture turned over */
  function flipPixels(d, src, axis) {
    return new Promise(function (res, rej) {
      var im = new d.defaultView.Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var c = d.createElement('canvas');
          c.width = im.naturalWidth; c.height = im.naturalHeight;
          var g = c.getContext('2d');
          if (axis === 'h') { g.translate(c.width, 0); g.scale(-1, 1); } else { g.translate(0, c.height); g.scale(1, -1); }
          g.drawImage(im, 0, 0);
          res(c.toDataURL('image/png'));
        } catch (e) { rej(e); }
      };
      im.onerror = rej;
      im.src = src;
    });
  }
  function mirrorSel(d, L, axis) {
    var ids = L.targetIds();
    if (!ids.length) return;
    L.flip(axis);
    L.state.els.filter(function (x) { return ids.indexOf(x.id) > -1; }).forEach(function (x) {
      if (x.type === 'image' && x.src) {
        var jobs = [flipPixels(d, x.src, axis)];
        if (x.origSrc && x.origSrc !== x.src) jobs.push(flipPixels(d, x.origSrc, axis)); else jobs.push(jobs[0]);
        Promise.all(jobs).then(function (r) { L.patchById(x.id, { src: r[0], origSrc: r[1] }, true); }, function () {});
      } else if (x.type === 'text') {
        /* text has no picture to turn over: a mirror flag is kept on the piece
           and drawn onto the letters after every paint */
        var cur = x.acpMirror || '';
        var next = (axis === 'h' ? (cur.indexOf('h') > -1 ? '' : 'h') : (cur.indexOf('h') > -1 ? 'h' : ''))
                 + (axis === 'v' ? (cur.indexOf('v') > -1 ? '' : 'v') : (cur.indexOf('v') > -1 ? 'v' : ''));
        L.patchById(x.id, { acpMirror: next }, true);
      }
    });
    setTimeout(function () { paintMirrors(d); }, 0);
  }
  function paintMirrors(d) {
    var L = logicOf(d);
    if (!L) return;
    var els = (L.state.els || []).filter(function (x) { return x.type === 'text'; });
    var any = els.some(function (x) { return x.acpMirror; });
    if (!any && !d.querySelector('[data-acp-mirrored]')) return;
    wrappersOf(d).forEach(function (w) {
      var inner = w.firstElementChild;
      if (!inner || inner.tagName === 'IMG') return;
      var id = idOfWrapper(L, w);
      var x = els.filter(function (e) { return e.id === id; })[0];
      var m = x && x.acpMirror ? x.acpMirror : '';
      var want = m ? 'scale(' + (m.indexOf('h') > -1 ? -1 : 1) + ', ' + (m.indexOf('v') > -1 ? -1 : 1) + ')' : '';
      if (want) {
        if (inner.style.transform !== want) inner.style.transform = want;
        inner.setAttribute('data-acp-mirrored', m);
      } else if (inner.hasAttribute('data-acp-mirrored')) {
        inner.style.transform = '';
        inner.removeAttribute('data-acp-mirrored');
      }
    });
  }
  function distributeGaps(L, axis) {
    var ids = L.state.sel;
    if (ids.length < 3) return;
    L.snap();
    var pos = axis === 'h' ? 'left' : 'top';
    var size = function (x) { return axis === 'h' ? x.w : L.elHeightPct(x); };
    var picked = L.state.els.filter(function (x) { return ids.indexOf(x.id) > -1; }).slice().sort(function (a, b) { return a[pos] - b[pos]; });
    var first = picked[0], last = picked[picked.length - 1];
    var span = (last[pos] + size(last) / 2) - (first[pos] - size(first) / 2);
    var total = picked.reduce(function (s, x) { return s + size(x); }, 0);
    var gap = (span - total) / (picked.length - 1);
    var cur = first[pos] - size(first) / 2, out = {};
    picked.forEach(function (x) { out[x.id] = cur + size(x) / 2; cur += size(x) + gap; });
    L.setState(function (st) { return { els: st.els.map(function (x) { return out[x.id] !== undefined ? Object.assign({}, x, axis === 'h' ? { left: out[x.id] } : { top: out[x.id] }) : x; }) }; });
  }
  function arrangeAct(d, what) {
    var L = logicOf(d);
    if (!L) return;
    if (what === 'mirrorH') mirrorSel(d, L, 'h');
    else if (what === 'mirrorV') mirrorSel(d, L, 'v');
    else if (what === 'centers') alignTo(L, ['centerX', 'middleY']);
    else if (what === 'distVC') L.distribute('v');
    else if (what === 'distHC') L.distribute('h');
    else if (what === 'distVE') distributeGaps(L, 'v');
    else if (what === 'distHE') distributeGaps(L, 'h');
    else alignTo(L, [what]);
  }
  /* Asked for: align lines the chosen pieces up with the FIRST chosen one
     (the tool lines up to the selection's outer edge). With one piece chosen,
     every other text/icon/logo on that side lines up to it. */
  function alignTo(L, kinds) {
    var sel = L.state.sel || [];
    if (!sel.length) return;
    var side = L.state.side || 'front';
    var others = L.state.els.filter(function (x) { return x.kind !== 'product' && (x.side || 'front') === side && sel.indexOf(x.id) === -1; }).map(function (x) { return x.id; });
    var ids = sel.length > 1 ? sel : sel.concat(others);
    var anchor = L.state.els.filter(function (x) { return x.id === sel[0]; })[0];
    if (!anchor || ids.length < 2) return;
    /* text boxes are far wider than the letters in them, so line up by what is
       actually drawn (the letters' own extent), not by the box */
    var ink = inkBoxes(L, ids);
    var a = ink[anchor.id] || boxOf(L, anchor);
    L.snap();
    L.setState(function (st) {
      return { els: st.els.map(function (x) {
        if (ids.indexOf(x.id) === -1 || x.id === anchor.id) return x;
        var b = ink[x.id] || boxOf(L, x), p = {};
        kinds.forEach(function (k) {
          if (k === 'left') p.left = x.left + (a.x0 - b.x0);
          else if (k === 'centerX') p.left = x.left + ((a.x0 + a.x1) - (b.x0 + b.x1)) / 2;
          else if (k === 'right') p.left = x.left + (a.x1 - b.x1);
          else if (k === 'top') p.top = x.top + (a.y0 - b.y0);
          else if (k === 'middleY') p.top = x.top + ((a.y0 + a.y1) - (b.y0 + b.y1)) / 2;
          else if (k === 'bottom') p.top = x.top + (a.y1 - b.y1);
        });
        return Object.assign({}, x, p);
      }) };
    });
  }
  function boxOf(L, x) {
    var h = L.elHeightPct(x);
    return { x0: x.left - x.w / 2, x1: x.left + x.w / 2, y0: x.top - h / 2, y1: x.top + h / 2 };
  }
  /* measure each piece's drawn extent in % of the area: for text the letters
     (via a range over the text node), for pictures the image box */
  function inkBoxes(L, ids) {
    var out = {};
    var area = L.areaRef && L.areaRef.current;
    if (!area) return out;
    var ar = area.getBoundingClientRect();
    var d = area.ownerDocument;
    var nodes = [].slice.call(area.children).filter(function (n) { return /translate\(-50%, -50%\)/.test(n.getAttribute('style') || ''); });
    var els = L.state.els.filter(function (x) { return ids.indexOf(x.id) > -1; });
    var onSide = L.state.els.filter(function (x) { return x.kind !== 'product' && (x.side || 'front') === (L.state.side || 'front'); });
    /* pieces render in state order; match by position to be safe */
    els.forEach(function (x) {
      var best = null, bd = 1e9;
      nodes.forEach(function (n) {
        var s = n.getAttribute('style') || '';
        var ml = /left:\s*([\d.]+)%/.exec(s), mt = /top:\s*([\d.]+)%/.exec(s);
        if (!ml || !mt) return;
        var dd = Math.abs(+ml[1] - x.left) + Math.abs(+mt[1] - x.top);
        if (dd < bd) { bd = dd; best = n; }
      });
      if (!best || bd > 0.5) return;
      var r;
      if (x.type === 'text') {
        var rg = d.createRange();
        var txt = best.querySelector('span, div');
        var walker = d.createTreeWalker(best, 4), t, first = null, last = null;
        while ((t = walker.nextNode())) { if (t.nodeValue.trim()) { if (!first) first = t; last = t; } }
        if (!first) return;
        rg.setStart(first, 0); rg.setEnd(last, last.nodeValue.length);
        r = rg.getBoundingClientRect();
        var rects = rg.getClientRects();
        if (rects.length) {
          var x0 = 1e9, x1 = -1e9, y0 = 1e9, y1 = -1e9;
          [].forEach.call(rects, function (q) { if (!q.width) return; x0 = Math.min(x0, q.left); x1 = Math.max(x1, q.right); y0 = Math.min(y0, q.top); y1 = Math.max(y1, q.bottom); });
          if (x1 > x0) r = { left: x0, right: x1, top: y0, bottom: y1 };
        }
      } else {
        var im = best.querySelector('img') || best;
        r = im.getBoundingClientRect();
      }
      if (!r || !(r.right > r.left)) return;
      out[x.id] = { x0: (r.left - ar.left) / ar.width * 100, x1: (r.right - ar.left) / ar.width * 100, y0: (r.top - ar.top) / ar.height * 100, y1: (r.bottom - ar.top) / ar.height * 100 };
    });
    return out;
  }

  function uploadButton(d) {
    var bar = d.querySelector('[data-acp-bar="image"]');
    if (!bar || bar.querySelector('[data-acp-btn="upload"]')) return;
    var eff = [].filter.call(bar.querySelectorAll('button'), function (b) { return /Effects$/.test((b.textContent || '').trim()); })[0];
    if (!eff) return;
    var wrap = eff.parentElement && eff.parentElement !== bar ? eff.parentElement : eff;
    var div = d.createElement('span');
    div.setAttribute('style', 'width: 1px; height: 28px; background: rgb(229, 231, 235); flex: 0 0 1px;');
    div.setAttribute('data-acp-btn', 'upload-div');
    var b = d.createElement('button');
    b.type = 'button';
    b.setAttribute('data-acp-btn', 'upload');
    b.setAttribute('style', eff.getAttribute('style') || '');
    b.title = 'Upload your file';
    var ic = d.createElement('span');
    ic.setAttribute('style', 'font-size: 15px;');
    ic.textContent = '\u2191';
    b.appendChild(ic);
    b.appendChild(d.createTextNode(' Upload your file'));
    /* the button sits in a wrapper so the file tray can hang under it */
    var hold = d.createElement('span');
    hold.setAttribute('data-acp-btn', 'upload-wrap');
    hold.setAttribute('style', 'position: relative; display: flex; align-items: center;');
    hold.appendChild(b);
    wrap.insertAdjacentElement('afterend', hold);
    wrap.insertAdjacentElement('afterend', div);
  }

  /* Asked for: "Upload your file" is for the customer's logos and designs;
     "Upload your product" is the product itself. The two never mix: a file
     picked from the toolbar is shown in its own tray under that button and is
     kept out of the Your Product tray; the product tray only shows product
     uploads. Clicking a file tile lays that file on the product as artwork. */
  function placeFile(d, L, item) {
    var was = L.state.tool;
    var base = L.__acpBasePlace || L.placeImage;
    L.setState({ tool: 'icons' }, function () {
      base.call(L, item);
      L.setState({ tool: was });
    });
  }
  var lastFiles = '';
  function splitTrays(d) {
    var L = logicOf(d);
    if (!L) return;
    var ups = L.state.uploads || [];
    var files = ups.filter(function (u) { return u && u.acpOrigin === 'file'; });
    var fileSrcs = files.map(function (u) { return u.src; });
    /* product tray: tiles of toolbar files are kept out of it */
    [].forEach.call(d.querySelectorAll('[aria-label="Place on product"], [title="Place on product"]'), function (t) {
      var im = t.querySelector('img');
      var card = t.parentElement;
      if (!im || !card || card.hasAttribute('data-acp-btn')) return;
      var isFile = fileSrcs.indexOf(im.getAttribute('src')) > -1;
      if (isFile && card.style.display !== 'none') { card.style.display = 'none'; card.setAttribute('data-acp-removed', 'file-upload'); }
      else if (!isFile && card.getAttribute('data-acp-removed') === 'file-upload') { card.style.display = ''; card.removeAttribute('data-acp-removed'); }
    });
    /* file tray under the toolbar button */
    var hold = d.querySelector('[data-acp-btn="upload-wrap"]');
    if (!hold) return;
    var tray = hold.querySelector('[data-acp-files]');
    var key = files.map(function (u) { return u.id; }).join(',');
    if (!files.length) { if (tray) tray.remove(); lastFiles = ''; return; }
    if (tray && key === lastFiles) return;
    lastFiles = key;
    if (!tray) {
      tray = d.createElement('div');
      tray.setAttribute('data-acp-files', '');
      tray.setAttribute('style', 'position: absolute; top: calc(100% + 10px); left: 0; z-index: 40; display: flex; gap: 8px; flex-wrap: wrap; max-width: 380px;'
        + 'background: rgb(255, 255, 255); border: 1px solid rgb(229, 231, 235); border-radius: 12px; padding: 8px;'
        + 'box-shadow: rgba(17, 24, 39, 0.12) 0px 2px 6px, rgba(17, 24, 39, 0.1) 0px 10px 24px;');
      hold.appendChild(tray);
    }
    tray.innerHTML = '';
    files.forEach(function (u) {
      var cell = d.createElement('span');
      cell.setAttribute('style', 'position: relative; display: block; width: 60px; height: 60px; flex: 0 0 60px;');
      var tile = d.createElement('button');
      tile.type = 'button';
      tile.title = 'Place on product';
      tile.setAttribute('data-acp-file', u.id);
      tile.setAttribute('style', 'width: 60px; height: 60px; border: 1px solid rgb(229, 231, 235); border-radius: 10px; background: rgb(246, 245, 243); padding: 4px; cursor: pointer; overflow: hidden;');
      var im = d.createElement('img');
      im.src = u.src;
      im.alt = u.name || '';
      im.setAttribute('style', 'width: 100%; height: 100%; object-fit: contain; display: block;');
      tile.appendChild(im);
      var x = d.createElement('button');
      x.type = 'button';
      x.title = 'Remove';
      x.setAttribute('data-acp-file-remove', u.id);
      x.setAttribute('style', 'position: absolute; top: -6px; right: -6px; width: 18px; height: 18px; border-radius: 50%; border: 1px solid rgb(229, 231, 235); background: rgb(255, 255, 255); font-size: 11px; line-height: 16px; padding: 0; cursor: pointer; color: rgb(17, 24, 39);');
      x.textContent = '\u2715';
      cell.appendChild(tile);
      cell.appendChild(x);
      tray.appendChild(cell);
    });
  }
  function openUpload(d) {
    var L = logicOf(d);
    if (!L) return;
    /* the tool's picker replaces the product when the product panels are
       open; this one always lays the file on top of the product as artwork,
       and never leaves the Our Product panel */
    var input = d.getElementById('acp-upload');
    if (!input) {
      input = d.createElement('input');
      input.type = 'file';
      input.id = 'acp-upload';
      input.accept = 'image/*';
      input.multiple = true;
      input.style.display = 'none';
      d.body.appendChild(input);
      input.addEventListener('change', function () {
        var files = [].slice.call(input.files || []);
        input.value = '';
        if (!files.length) return;
        var was = L.state.tool;
        var origPlace = L.placeImage;
        L.placeImage = function (item) {
          item.acpOrigin = 'file';
          var st = L.state;
          L.setState({ tool: 'icons' }, function () {
            (L.__acpBasePlace || origPlace).call(L, item);
            L.setState({ tool: was });
          });
        };
        Promise.resolve(L.onFilesPicked(files)).then(function () { L.placeImage = origPlace; }, function () { L.placeImage = origPlace; });
      });
    }
    input.click();
  }

  /* Asked for: the Font button opens a scrollable list of fonts right under
     it (grouped as the tool groups them, each shown in its own face) instead
     of sending the visitor to the Text side panel. */
  function fontButton(d) {
    return [].filter.call(d.querySelectorAll('[data-acp-bar="text"] button'), function (b) {
      return /\u25BE/.test(b.textContent || '') && /Font:/.test((b.parentElement && b.parentElement.textContent) || '');
    })[0];
  }
  function closeFontList(d) {
    var m = d.getElementById('acp-fonts');
    if (m) m.remove();
  }
  function openFontList(d, btn) {
    closeFontList(d);
    var L = logicOf(d);
    if (!L) return;
    var groups = [];
    try { groups = L.renderVals().fontGroups || []; } catch (e) {}
    var m = d.createElement('div');
    m.id = 'acp-fonts';
    m.setAttribute('style', 'position: absolute; top: calc(100% + 6px); left: 0; z-index: 50; width: 240px; max-height: 300px; overflow-y: auto;'
      + 'background: rgb(255, 255, 255); border: 1px solid rgb(229, 231, 235); border-radius: 10px;'
      + 'box-shadow: rgba(17, 24, 39, 0.12) 0px 2px 6px, rgba(17, 24, 39, 0.1) 0px 10px 24px; padding: 6px;');
    groups.forEach(function (g) {
      var h = d.createElement('div');
      h.setAttribute('style', 'font-size: 11px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; color: rgb(107, 114, 128); padding: 8px 10px 4px;');
      h.textContent = g.cat;
      m.appendChild(h);
      (g.items || []).forEach(function (it) {
        var o = d.createElement('button');
        o.type = 'button';
        o.setAttribute('data-acp-font', it.value);
        o.setAttribute('style', 'display: flex; width: 100%; align-items: center; justify-content: space-between; text-align: left; border: 0;'
          + 'background: ' + (it.active ? 'rgb(243, 244, 246)' : 'transparent') + '; border-radius: 6px; padding: 8px 10px; cursor: pointer;'
          + 'font-family: ' + it.value + '; font-size: 18px; line-height: 1.1; color: rgb(17, 24, 39);');
        o.textContent = it.label;
        if (it.active) {
          var tick = d.createElement('span');
          tick.setAttribute('style', 'font-family: inherit; font-size: 14px;');
          tick.textContent = '\u2713';
          o.appendChild(tick);
        }
        m.appendChild(o);
      });
    });
    btn.parentElement.appendChild(m);
    var act = m.querySelector('[style*="rgb(243, 244, 246)"]');
    if (act) m.scrollTop = Math.max(0, act.offsetTop - 100);
  }

  /* Asked for: a colour option beyond the three fixed dots — a fourth dot
     with a colour-wheel ring that opens the browser's colour picker and
     applies the choice to the selected text. */
  function colourPicker(d) {
    var bar = d.querySelector('[data-acp-bar="text"]');
    if (!bar || bar.querySelector('[data-acp-btn="colour"]')) return;
    var dots = bar.querySelectorAll('button[title="Text colour"]');
    if (!dots.length) return;
    var last = dots[dots.length - 1];
    var b = d.createElement('button');
    b.type = 'button';
    b.setAttribute('data-acp-btn', 'colour');
    b.title = 'Custom colour';
    b.setAttribute('style', 'width: 26px; height: 26px; border: 2px solid rgb(229, 231, 235); border-radius: 50%; cursor: pointer; padding: 0px; flex: 0 0 26px; position: relative; overflow: hidden;'
      + 'background: conic-gradient(rgb(224, 27, 27), rgb(250, 176, 5), rgb(34, 160, 63), rgb(30, 42, 138), rgb(160, 32, 240), rgb(224, 27, 27));');
    var input = d.createElement('input');
    input.type = 'color';
    input.setAttribute('data-acp-colour-input', '');
    input.setAttribute('style', 'position: absolute; inset: 0; opacity: 0; width: 100%; height: 100%; cursor: pointer; border: 0; padding: 0;');
    input.addEventListener('input', function () {
      var L = logicOf(d);
      var v = input.value;
      if (L) try { L.patchActive(function () { return { color: v }; }); } catch (e) {}
    });
    input.addEventListener('click', function (e) { e.stopPropagation(); });
    b.appendChild(input);
    last.insertAdjacentElement('afterend', b);
  }

  /* Asked for: the colour dots and picker also recolour a selected logo /
     upload (for visibility on the product — a black logo made white, say). The
     picture's shape is kept and filled with the colour; the untinted picture
     is remembered so a new colour starts from it, not from the last tint. */
  function tintImage(L, el, color) {
    var base = (el.acpTinted && el.src === el.acpTinted) ? el.acpBase : el.src;
    L.loadImg(base).then(function (img) {
      var c = document.createElement('canvas');
      c.width = img.naturalWidth || img.width; c.height = img.naturalHeight || img.height;
      var x = c.getContext('2d');
      x.drawImage(img, 0, 0);
      x.globalCompositeOperation = 'source-in';
      x.fillStyle = color;
      x.fillRect(0, 0, c.width, c.height);
      var url = c.toDataURL('image/png');
      L.patchById(el.id, { src: url, acpBase: base, acpTinted: url, color: color });
    }).catch(function () {});
  }
  function hookColour(d) {
    var L = logicOf(d);
    if (!L || L.__acpTint) return;
    L.__acpTint = true;
    var orig = L.patchActive.bind(L);
    L.patchActive = function (fn) {
      var st = L.state;
      var a = st.els.filter(function (x) { return st.sel.indexOf(x.id) > -1; }).slice(-1)[0];
      var patch = null;
      try { patch = a ? fn(a) : null; } catch (e) {}
      if (a && a.type === 'image' && a.kind !== 'product' && patch && patch.color && Object.keys(patch).length === 1) {
        tintImage(L, a, patch.color);
        return;
      }
      return orig(fn);
    };
  }

  /* Asked for: a live preview of the design under the product card in the Our
     Product panel — the same scaled copy of the stage as the thumbnail, at
     panel width. */
  var lastPanel = '';
  function panelPreview(d) {
    var safe = d.querySelector('[style*="dashed"]');
    var stage = safe && safe.parentElement;
    var card = [].filter.call(d.querySelectorAll('button'), function (b) {
      var t = (b.textContent || '').trim();
      return /\$\d/.test(t) && t.length < 90 && b.style.display !== 'none' && b.querySelector('img');
    })[0];
    var old = d.getElementById('acp-panel-preview');
    if (!stage || !card) { if (old) old.remove(); return; }
    var list = card.parentElement;
    var box = old;
    if (!box) {
      box = d.createElement('div');
      box.id = 'acp-panel-preview';
      box.setAttribute('style', 'position: relative; width: 100%; aspect-ratio: 1 / 1; border: 1px solid rgb(229, 231, 235); border-radius: 8px; overflow: hidden; background: rgb(243, 244, 246);');
      list.appendChild(box);
      lastPanel = '';
    } else if (box.parentElement !== list) {
      list.appendChild(box);
    }
    var html = stage.innerHTML;
    if (html === lastPanel && box.firstChild) return;
    lastPanel = html;
    var r = stage.getBoundingClientRect(), W = r.width || 420, H = r.height || 420;
    var bw = box.clientWidth || 272, bh = box.clientHeight || bw;
    if (!bw) return;
    var k = Math.max(bw / W, bh / H);
    box.innerHTML = '';
    box.appendChild(cloneStage(d, stage, W, H, k, (bw - W * k) / 2, (bh - H * k) / 2));
  }
  function cloneStage(d, stage, W, H, k, ox, oy) {
    var clone = stage.cloneNode(true);
    clone.removeAttribute('data-dc-tpl');
    clone.style.cssText += ';position:absolute;left:' + ox + 'px;top:' + oy + 'px;'
      + 'width:' + W + 'px;height:' + H + 'px;transform:scale(' + k + ');transform-origin:0 0;'
      + 'border-radius:0;box-shadow:none;aspect-ratio:auto;max-height:none;pointer-events:none;';
    [].forEach.call(clone.querySelectorAll('*'), function (el) {
      var s = el.getAttribute('style') || '';
      if (s.indexOf('rgb(255, 45, 155)') > -1 || s.indexOf('calc(100% + 1') > -1
          || (s.indexOf('dashed') > -1 && s.indexOf('inset:') > -1 && el !== clone)) {
        if (s.indexOf('dashed') > -1) { el.style.border = 'none'; }
        else el.style.display = 'none';
      }
      if (el.tagName === 'TEXTAREA') {
        var t = d.createElement('div');
        t.setAttribute('style', s + ';white-space:pre;');
        t.textContent = el.value;
        el.parentNode.replaceChild(t, el);
      }
    });
    var tag = clone.querySelector('span[style*="top: -11px"]');
    if (tag) tag.style.display = 'none';
    [].forEach.call(clone.querySelectorAll('[data-acp-sel],[data-acp-group]'), function (el) { el.style.outline = 'none'; });
    return clone;
  }

  /* Asked for: a compact Front / Back / Both sides choice under the product
     card, with prices. One side costs the product price; both sides cost the
     BOTH_PRICES figure for that product (Metal Business Card: $50). Choosing a
     side shows that photo; choosing Both turns the thumbnails into two real
     sides, each with its own photo and its own design. The chosen price is
     what the Review step shows. */
  var BOTH_PRICES = { 'metal business card': 50 };
  /* ---------- Shopify sync ----------
     The store is the source of truth. Each product's variants are read from
     /products.json: an "Engrave" option with Front / Back / Both sides gives
     that product a price per side and a variant per side; a product with no
     such option is one-sided and only the Front is offered. The chosen
     variant is what goes to checkout, with the design attached to the line. */
  var VARIANTS = null;
  function loadVariants(d, L) {
    if (VARIANTS || d.__acpVarBusy) return;
    d.__acpVarBusy = true;
    d.defaultView.fetch(L.shopBase() + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var v = {};
        (data.products || []).forEach(function (p) {
          var opt = (p.options || []).map(function (o, i) { return { i: i, name: String(o.name || '').toLowerCase() }; })
            .filter(function (o) { return /engrav|side/.test(o.name); })[0]
            /* any option whose values read Front/Back/Left/Right/Both counts, whatever it is named */
            || (p.options || []).map(function (o, i) { return { i: i }; }).filter(function (o) {
              return (p.variants || []).some(function (vr) { return /^\s*(front|back|left|right|both)/i.test(String(vr['option' + (o.i + 1)] || '')); });
            })[0];
          var rec = { sides: {}, single: (p.variants || [])[0] || null, twoSided: false, photos: (p.images || []).length }; rec.photos2 = {}; (p.images || []).forEach(function (im) { var vid = (im.variant_ids || [])[0]; var vr = (p.variants || []).filter(function (x) { return x.id === vid; })[0]; if (vr) rec.photos2[acpBase(im.src)] = { id: vr.id, price: vr.price }; });
          if (opt) {
            (p.variants || []).forEach(function (vr) {
              var val = String(vr['option' + (opt.i + 1)] || '').toLowerCase();
              var k = /both/.test(val) ? 'both' : /back|right/.test(val) ? 'back' : /front|left/.test(val) ? 'front' : null;
              if (k) rec.sides[k] = { id: vr.id, price: vr.price, available: vr.available !== false };
            });
            rec.twoSided = !!(rec.sides.back || rec.sides.both);
          }
          v[String(p.handle).toLowerCase()] = rec;
          v[String(p.title).toLowerCase()] = rec;
        });
        VARIANTS = v;
        d.__acpVarBusy = false;
        try { sideChooser(d); } catch (e) {}
      })
      .catch(function () { setTimeout(function () { d.__acpVarBusy = false; }, 4000); });
  }
  var LAST_L = null; function acpBase(src) { return String(src || '').split('?')[0].split('/').pop().replace(/_(\d+x\d*|x\d+)(\.[a-z]+)$/i, '$2'); } function photoVar(rec) { try { if (!rec || !rec.photos2 || !LAST_L) return null; var el = (LAST_L.state.els || []).filter(function (e) { return e.kind === 'product' && (e.side || 'front') === 'front'; })[0]; return el ? (rec.photos2[acpBase(el.src)] || null) : null; } catch (e) { return null; } } function variantsFor(pick) {
    if (!VARIANTS || !pick) return null;
    return VARIANTS[String(pick.handle || '').toLowerCase()] || VARIANTS[String(pick.title || '').toLowerCase()] || null;
  }
  /* the variant and price for a side choice; falls back to the single variant
     and the old list price when the store has no side option */
  function sidePick(pick, m) {
    var rec = variantsFor(pick);
    var base = pick.acpBase != null ? pick.acpBase : pick.price;
    if (rec && rec.sides[m]) return { id: rec.sides[m].id, price: rec.sides[m].price };
    var pv = photoVar(rec); if (pv) return { id: pv.id, price: pv.price }; if (rec && m === 'front' && rec.single) return { id: rec.single.id, price: rec.single.price };
    return { id: pick.acpVariant || pick.variantId, price: m === 'both' ? bothPrice(Object.assign({}, pick, { price: base })) : base };
  }
  function twoSidedPick(pick) {
    var rec = variantsFor(pick);
    if (rec) return rec.twoSided;
    return true; /* unknown yet: keep the choice open until the store answers */
  }
  /* checkout: the chosen side's variant, with the design on the order line */
  function hookCheckout(d, L) {
    LAST_L = L; if (L.__acpCheckout) return;
    L.__acpCheckout = true;
    var origRV = L.renderVals.bind(L);
    L.renderVals = function () {
      var v = origRV();
      /* Your Product review: "Send for Quote" becomes "Download mockup" — the
         PNG is saved and the visitor emails it to the shop by hand */
      if (typeof v.onSendQuote === 'function') {
        var origQuote = v.onSendQuote;
        v.onSendQuote = function () {
          var done = function () { return origQuote(); };
          /* Asked for: every piece downloads, not only the one on screen —
             Your Product saves one PNG per side (mockup-1.png, -2, -3 …);
             Both sides saves front and back */
          var ids = [];
          if (ws === 'yours') { for (var i = 0; i < Math.max(1, yourTray(L).length); i++) ids.push(sideIdAt(i)); }
          else if (mode === 'both') ids = ['front', 'back'];
          else ids = [L.state.side || 'front'];
          var origSide = L.state.side, origCur = L.curEls;
          var run = Promise.resolve();
          ids.forEach(function (id, n) {
            run = run.then(function () {
              L.state.side = id;
              L.curEls = function () { return (L.state.els || []).filter(function (e) { return (e.side || 'front') === id; }); };
              var orig = d.createElement.bind(d);
              /* the tool names every file mockup.png; each side gets its number */
              d.createElement = function (tag) { var el = orig(tag); if (String(tag).toLowerCase() === 'a') {
                var desc = Object.getOwnPropertyDescriptor(HTMLAnchorElement.prototype, 'download');
                Object.defineProperty(el, 'download', { set: function (v) { desc.set.call(el, ids.length > 1 ? 'mockup-' + (n + 1) + '.png' : v); }, get: function () { return desc.get.call(el); } }); }
                return el; };
              var fin = function () { d.createElement = orig; };
              try { var r = L.exportPng(); if (r && r.then) return r.then(fin, fin); } catch (e) {}
              fin();
            }).then(function () { return new Promise(function (res) { setTimeout(res, 350); }); });
          });
          return run.then(function () { L.state.side = origSide; L.curEls = origCur; return done(); },
                          function () { L.state.side = origSide; L.curEls = origCur; return done(); });
        };
      }
      if (typeof v.onCheckout === 'function') {
        var orig = v.onCheckout;
        v.onCheckout = function () {
          var win = d.defaultView;
          var site = null;
          try { site = win.parent && win.parent !== win && win.parent.ArcherCustomizer && (win.parent.__SHOPIFY__ || {}).store ? win.parent : null; } catch (e) { site = null; }
          /* the visitor's own piece: nothing of ours to sell — on the shop it
             goes to the site cart as an own piece (priced by hand / quoted) */
          if (ws === 'yours' && site) {
            var ownProps = designProps(d, L);
            var ownLines = Object.keys(ownProps).filter(function (k) { return / design$/.test(k); })
              .map(function (k) { return k.replace(/ design$/, '') + ': ' + ownProps[k]; }).join(' · ');
            var qp = site.__QUOTE_PRODUCT__ || null;
            site.postMessage({ type: 'archer-design', slug: (qp && qp.s) || 'own', piece: 'Your own piece', own: true,
              variant: (qp && qp.variant) || null, price: qp ? parseFloat(qp.p) || 0 : 0, qty: L.state.qty || 1,
              engraving: ownLines || 'Your own piece', typeface: '\u2014', props: Object.assign({ 'Custom design': 'Customer\u2019s own piece' }, ownProps) }, '*');
            try { site.ArcherCustomizer.close(); } catch (e) {}
            L.setState({ cart: 'added' });
            return;
          }
          var p = L.state.shopPick;
          if (!p) return orig();
          var sp = sidePick(p, mode);
          if (!sp.id) return orig();
          var props = designProps(d, L);
          var qty = L.state.qty || 1;
          var label = mode === 'both' ? 'Front and back artwork' : mode === 'back' ? 'Back side artwork' : 'Front side artwork';
          /* fallback: the cart permalink (order attributes only) */
          var link = L.shopBase() + '/cart/' + sp.id + ':' + qty + '?attributes[Custom design]=' + encodeURIComponent(label);
          Object.keys(props).forEach(function (k) { link += '&attributes[' + encodeURIComponent(k) + ']=' + encodeURIComponent(props[k]); });
          var lineProps = Object.assign({ 'Custom design': label }, props);
          /* on the shop the design lands in the SITE cart (one cart, with
             Remove and quantities); the site mirrors it into Shopify's cart and
             its Checkout hands over to Shopify. Nothing is added to Shopify
             from here, so lines can never pile up or go stale. */
          if (site) {
            var fonts = [];
            Object.keys(props).forEach(function (k) { var m = /\(([^)]+)\)/.exec(props[k] || ''); if (/ design$/.test(k) && m && fonts.indexOf(m[1]) < 0) fonts.push(m[1]); });
            var engraving = Object.keys(props).filter(function (k) { return / design$/.test(k); })
              .map(function (k) { return k.replace(/ design$/, '') + ': ' + props[k]; }).join(' · ');
            site.postMessage({ type: 'archer-design', slug: p.handle || p.s || '', piece: p.title || p.n || '',
              variant: sp.id, price: parseFloat(sp.price || p.price) || 0, qty: qty, own: false,
              engraving: engraving || label, typeface: fonts.join(', ') || '\u2014', props: lineProps }, '*');
            try { site.ArcherCustomizer.close(); } catch (e) {}
            L.setState({ cart: 'added' });
            return;
          }
          /* anywhere else: the cart permalink, in a tab opened at once (a
             later open would be blocked) */
          var tab = win.open('about:blank', '_blank');
          var go = function (url) { if (tab && !tab.closed) tab.location.replace(url); else win.open(url, '_blank', 'noopener'); };
          go(link);
          /* the real checkout is in Shopify's tab; the tool's own mock
             "Shopify checkout" card is never shown */
          L.setState({ cart: 'added' });
        };
      }
      return v;
    };
  }
  /* what the engraver needs: which side(s), every text line, icon and upload */
  function designProps(d, L) {
    var out = {};
    var sides = mode === 'both' ? ['front', 'back'] : [mode];
    if (ws === 'yours') {
      /* Your Product: every side (one per uploaded piece) that has anything on it */
      sides = [];
      (L.state.els || []).forEach(function (x) { var sd = x.side || 'front'; if (sides.indexOf(sd) < 0) sides.push(sd); });
      sides.sort(function (a, b) { return sideIndex(a) - sideIndex(b); });
      if (!sides.length) sides = ['front'];
    }
    sides.forEach(function (s) {
      var lines = [];
      (L.state.els || []).forEach(function (x) {
        if (x.kind === 'product' || (x.side || 'front') !== s) return;
        var isText = x.type === 'text' || (x.type == null && typeof x.text === 'string');
        if (isText && x.kind === 'icon') lines.push('icon ' + x.text);
        else if (isText) {
          var t = String(x.text || '').trim();
          if (!t || /^type here$/i.test(t)) return; /* untouched placeholder */
          lines.push('text "' + t.slice(0, 80) + '" (' + String(x.font || 'default').replace(/^'|'.*$/g, '') + ')');
        }
        else if (x.type === 'image' || x.src) lines.push('upload' + (x.bgRemoved ? ' (background removed)' : ''));
      });
      out[sideLabel(s) + ' design'] = lines.length ? lines.join('; ').slice(0, 250) : 'plain';
    });
    out['Engrave'] = mode === 'both' ? 'Both sides' : mode === 'back' ? 'Back' : 'Front';
    return out;
  }
  var mode = 'front';
  function money(n) { return '$' + Number(n).toFixed(2); }
  function bothPrice(pick) {
    var key = String(pick && pick.title || '').toLowerCase();
    if (BOTH_PRICES[key] != null) return BOTH_PRICES[key];
    return Math.round((parseFloat(pick && pick.price) || 0) * 1.25 * 100) / 100;
  }
  function sideChooser(d) {
    var L = logicOf(d);
    var card = [].filter.call(d.querySelectorAll('button'), function (b) {
      var t = (b.textContent || '').trim();
      return /\$\d/.test(t) && t.length < 90 && b.style.display !== 'none' && b.querySelector('img');
    })[0];
    var box = d.getElementById('acp-sides');
    if (box && box.getAttribute('data-acp-v') !== '2') { box.remove(); box = null; }
    /* Your Product: the same chooser sits under the uploads (the piece is the
       visitor's own, priced as the chosen store item) */
    var yourPanel = null;
    if (L && L.state.tool === 'product') {
      var fi = d.querySelector('label input[type="file"]');
      var lab = fi && fi.closest('label');
      yourPanel = lab && lab.parentElement;
    }
    if (!L || !L.state.shopPick || (!card && !yourPanel)) { if (box) box.remove(); return; }
    var list = yourPanel || card.parentElement;
    var pick = L.state.shopPick;
    loadVariants(d, L); hookCheckout(d, L);
    var single = sidePick(pick, 'front').price;
    var both = sidePick(pick, 'both').price;
    var backP = sidePick(pick, 'back').price;
    var two = yourPanel ? true : twoSidedPick(pick);
    /* one-sided product: only the Front is offered; the choice snaps back */
    if (!two && mode !== 'front') { mode = 'front'; setTimeout(function () { try { chooseMode(d, 'front'); } catch (e) {} }, 0); }
    if (!box) {
      box = d.createElement('div');
      box.id = 'acp-sides';
      box.setAttribute('data-acp-v', '2');
      box.setAttribute('style', 'display: flex; flex-direction: column; gap: 6px; margin-top: 12px;');
      var lab = d.createElement('div');
      lab.setAttribute('style', 'font-size: 13px; font-weight: 600; color: rgb(17, 24, 39);');
      lab.textContent = 'Engrave';
      var row = d.createElement('div');
      row.setAttribute('style', 'display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 6px;');
      [['front', 'Front'], ['back', 'Back'], ['both', 'Both sides']].forEach(function (o) {
        var b = d.createElement('button');
        b.type = 'button';
        b.setAttribute('data-acp-side', o[0]);
        b.setAttribute('style', 'display: flex; flex-direction: column; align-items: center; gap: 2px; padding: 8px 4px; border: 1px solid rgb(229, 231, 235); border-radius: 8px; background: rgb(255, 255, 255); cursor: pointer; font-family: inherit; position: relative;');
        var n = d.createElement('span'); n.setAttribute('style', 'font-size: 13px; font-weight: 600;'); n.textContent = o[1];
        var p = d.createElement('span'); p.setAttribute('style', 'font-size: 12px;'); p.setAttribute('data-acp-price', '');
        var tick = d.createElement('span');
        tick.setAttribute('data-acp-tick', '');
        tick.setAttribute('style', 'position: absolute; left: 6px; top: 6px; width: 14px; height: 14px; border-radius: 50%; background: rgb(30, 42, 138); color: rgb(255, 255, 255); font-size: 9px; line-height: 14px; text-align: center; display: none;');
        tick.textContent = '\u2713';
        b.appendChild(tick); b.appendChild(n); b.appendChild(p);
        row.appendChild(b);
      });
      box.appendChild(lab); box.appendChild(row);
      if (yourPanel) list.appendChild(box); else list.insertAdjacentElement('afterend', box);
    } else if (yourPanel ? box.parentElement !== list : box.previousElementSibling !== list) {
      if (yourPanel) list.appendChild(box); else list.insertAdjacentElement('afterend', box);
    }
    [].forEach.call(box.querySelectorAll('[data-acp-side]'), function (b) {
      var side = b.getAttribute('data-acp-side');
      var on = side === mode;
      b.style.display = (two || side === 'front') ? 'flex' : 'none';
      /* chosen: blue check mark at the left of the box, blue outline */
      b.style.background = 'rgb(255, 255, 255)';
      b.style.color = 'rgb(17, 24, 39)';
      b.style.borderColor = on ? 'rgb(30, 42, 138)' : 'rgb(229, 231, 235)';
      b.style.borderWidth = on ? '1.5px' : '1px';
      b.querySelector('[data-acp-tick]').style.display = on ? 'block' : 'none';
      /* Your Product: the visitor's own item is priced by quote, not list */
      b.querySelector('[data-acp-price]').textContent = yourPanel ? 'Quote' : money(side === 'both' ? both : side === 'back' ? backP : single);
    });
    box.querySelector('div:last-child').style.gridTemplateColumns = two ? 'repeat(3, minmax(0, 1fr))' : 'minmax(0, 1fr)';
    /* the Review step shows the price of the chosen option (set when the
       option is chosen, and once here when the product first arrives) */
    var want = sidePick(pick, mode).price;
    var wantVar = sidePick(pick, mode).id;
    if (!L.__acpPricing && (parseFloat(pick.price) !== parseFloat(want) || pick.acpBase == null || pick.acpVariant == null || (wantVar && pick.variantId !== wantVar))) {
      L.__acpPricing = true;
      setTimeout(function () {
        try { L.setState({ shopPick: Object.assign({}, L.state.shopPick, { acpBase: single, acpVariant: L.state.shopPick.acpVariant || L.state.shopPick.variantId, price: String(want), variantId: wantVar || L.state.shopPick.variantId }) }); } catch (e) {}
        L.__acpPricing = false;
      }, 0);
    }
  }
  function ensureSide(L, side, src) {
    var has = L.state.els.some(function (e) { return e.kind === 'product' && (e.side || 'front') === side; });
    if (has || !src) return;
    L.loadImg(src).then(function (im) { return im.width / im.height; }, function () { return 1; }).then(function (aspect) {
      L.setState(function (st) {
        return { els: st.els.concat([{ id: st.nextId, side: side, type: 'image', kind: 'product', source: 'ours',
          src: src, origSrc: src, aspect: aspect, left: 50, top: 50, w: 100, bgRemoved: false }]), nextId: st.nextId + 1 };
      });
    });
  }
  function chooseMode(d, m) {
    var L = logicOf(d);
    if (!L) return;
    mode = m;
    if (m === 'both') {
      var imgs = productPhotos(d, L);
      if (imgs) { ensureSide(L, 'front', imgs[0]); ensureSide(L, 'back', imgs[1]); }
      /* stay on the side that is open; make sure its photo is the right one */
      var side = L.state.side || 'front';
      face = side === 'back' ? 1 : 0;
      if (imgs && imgs[face]) {
        var cur = L.state.els.filter(function (e) { return e.kind === 'product' && (e.side || 'front') === side; }).slice(-1)[0];
        if (cur && cur.src !== imgs[face]) showFace(d, L, face);
      }
    } else {
      if ((L.state.side || 'front') !== 'front') L.setState({ side: 'front', sel: [], editingId: null });
      showFace(d, L, m === 'back' ? 1 : 0);
    }
    sideChooser(d); markFaces(d);
  }

  var applying = false, applyTimes = [];
  /* ---------- Review step thumbnails ----------
     Asked for: the Review step's tiles are the design's Front and Back — the
     same live previews as on the Design step — and the "lifestyle mockup" tile
     goes. The tool draws the Front tile as a blank card and two placeholder
     tiles; the first two are relabelled and filled here, the third is hidden.
     Clicking a tile shows that side on the big preview. */
  var lastReview = '';
  function reviewTiles(d) {
    var L = logicOf(d);
    if (!L || L.state.step !== 'Review') { lastReview = ''; return; }
    var tiles = [].filter.call(d.querySelectorAll('div'), function (e) {
      var s = e.getAttribute('style') || '';
      return s.indexOf('aspect-ratio: 1 / 1') > -1 && e.parentElement && /flex: 0 0 92px/.test(e.parentElement.getAttribute('style') || '');
    });
    if (tiles.length < 3) return;
    /* Your Product: one tile per uploaded piece — the tool draws two; more
       are cloned from the second and given their own side */
    var wantN = ws === 'yours' ? Math.max(2, yourTray(L).length) : 2;
    var extras = [].filter.call(tiles, function (t) { return t.hasAttribute('data-acp-review-extra'); });
    var baseTiles = tiles.filter(function (t) { return !t.hasAttribute('data-acp-review-extra'); });
    while (baseTiles.length - 1 + extras.length < wantN) {
      var cl = baseTiles[1].cloneNode(false);
      cl.setAttribute('data-acp-review-extra', '');
      baseTiles[1].parentElement.insertBefore(cl, baseTiles[2]);
      extras.push(cl);
    }
    while (baseTiles.length - 1 + extras.length > wantN) { var gone = extras.pop(); gone.parentElement && gone.parentElement.removeChild(gone); }
    tiles = baseTiles.slice(0, 2).concat(extras, baseTiles.slice(2));
    var big = [].filter.call(d.querySelectorAll('[style*="inset: 6.5%"]'), function (s) { return s.parentElement && /min\(420px/.test(s.parentElement.getAttribute('style') || ''); })[0];
    var stage = big && big.parentElement;
    if (!stage) return;
    tiles[wantN].style.display = 'none';
    tiles[wantN].setAttribute('data-acp-removed', 'lifestyle');
    var side = L.state.side || 'front';
    var names = ws === 'yours' ? tiles.slice(0, wantN).map(function (_, i) { return String(i + 1); }) : ['Front', 'Back'];
    var imgs = productPhotos(d, L);
    var html = stage.innerHTML + '|' + side + '|' + mode;
    var changed = html !== lastReview;
    lastReview = html;
    tiles.slice(0, wantN).forEach(function (t, i) {
      var isSide = sideIdAt(i);
      var on = isSide === side;
      var chosen = on || mode === 'both' || ws === 'yours';
      t.setAttribute('data-acp-review', isSide);
      /* Asked for: Front chosen shows only the Front tile, Back chosen only
         the Back tile; Both shows both. Your Product: every piece shows. */
      t.style.display = (ws === 'yours' || mode === 'both' || mode === isSide) ? '' : 'none';
      t.style.cursor = 'pointer';
      /* Both sides: both tiles are chosen; the one on the big preview gets a ring */
      t.style.border = chosen ? '2px solid rgb(30, 42, 138)' : '1px solid rgb(229, 231, 235)';
      t.style.boxShadow = (chosen && on && (mode === 'both' || ws === 'yours')) ? '0 0 0 2px rgba(30, 42, 138, .25)' : 'none';
      t.style.background = 'rgb(246, 245, 243)';
      t.style.position = 'relative';
      t.style.overflow = 'hidden';
      var lab = t.querySelector('[data-acp-review-label]');
      if (!lab) {
        /* the tool's own contents (blank card / stripes / caption) are hidden */
        [].forEach.call(t.children, function (c) { c.style.display = 'none'; });
        var live = d.createElement('div');
        live.setAttribute('data-acp-review-live', '');
        live.style.cssText = 'position:absolute;inset:0;overflow:hidden;pointer-events:none;';
        t.appendChild(live);
        lab = d.createElement('span');
        lab.setAttribute('data-acp-review-label', '');
        lab.setAttribute('style', 'position: absolute; left: 0px; right: 0px; bottom: 0px; background: rgba(17, 24, 39, 0.55); color: rgb(255, 255, 255); font-size: 11px; text-align: center; padding: 3px 0px; pointer-events: none;');
        t.appendChild(lab);
      }
      lab.textContent = names[i];
      /* the tool redraws its own placeholder (blank card / in-situ mockup)
         on re-render; it is kept hidden on every pass */
      [].forEach.call(t.children, function (c) {
        if (!c.hasAttribute('data-acp-review-live') && !c.hasAttribute('data-acp-review-label') && c.style.display !== 'none') c.style.display = 'none';
      });
      var live2 = t.querySelector('[data-acp-review-live]');
      if (!changed && live2.firstChild) return;
      live2.innerHTML = '';
      var bw = t.clientWidth || 88, bh = t.clientHeight || 88;
      if (on) {
        var r = stage.getBoundingClientRect(), W = r.width || 420, H = r.height || 420;
        var k = Math.max(bw / W, bh / H);
        live2.appendChild(cloneStage(d, stage, W, H, k, (bw - W * k) / 2, (bh - H * k) / 2));
      } else {
        /* the other side: its own design when both sides are engraved,
           otherwise that side's plain product photo */
        var src = imgs && imgs[i];
        var elsSide = L.state.els.filter(function (e) { return (e.side || 'front') === isSide && e.kind === 'product'; });
        if (elsSide.length && elsSide[0].src) src = elsSide[0].src;
        if (src) {
          var im = d.createElement('img');
          im.alt = '';
          im.src = src;
          im.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;';
          live2.appendChild(im);
        }
      }
    });
  }

  /* Asked for: the header reads as two steps — 1 Our Product Design,
     2 Review. The tool's project-name label ("Our Product") and its Design
     tab are joined: the label is hidden, the Design tab is relabelled, and a
     small numbered dot goes in front of each step. */
  function stepNumbers(d) {
    var names = { 'design': 1, 'our product design': 1, 'review': 2, 'review checkout': 2 };
    var header = d.querySelector('header');
    if (!header) return;
    var targets = [].slice.call(header.querySelectorAll('button'));
    [].forEach.call(header.children, function (c) {
      if (c.tagName === 'DIV' && /^our product$/i.test((c.textContent || '').replace(/\s+/g, ' ').trim())) {
        c.style.display = 'none';
        c.setAttribute('data-acp-removed', 'project-label');
        /* room between Save & Exit and the steps */
        if (c.nextElementSibling) c.nextElementSibling.style.marginLeft = '40px';
      }
    });
    targets.forEach(function (b) {
      var label = b.querySelector('.sc-interp');
      if (label && /^design$/i.test((label.textContent || '').trim())) label.textContent = 'Our Product Design';
      if (label && /^review$/i.test((label.textContent || '').trim())) label.textContent = 'Review + Checkout';
      if (b.querySelector('[data-acp-step]')) return;
      var t = (b.textContent || '').replace(/[^a-z ]/gi, '').replace(/\s+/g, ' ').trim().toLowerCase();
      var n = names[t];
      if (!n) return;
      var dot = d.createElement('span');
      dot.setAttribute('data-acp-step', String(n));
      dot.setAttribute('style', 'display: inline-flex; align-items: center; justify-content: center; width: 18px; height: 18px; border-radius: 50%;'
        + 'border: 1.5px solid currentColor; font-size: 11px; font-weight: 700; margin-right: 7px; vertical-align: -3px; line-height: 1; flex: 0 0 18px;');
      dot.textContent = String(n);
      /* the tool's own glyph before "Our Product" gives way to the number */
      var glyph = b.firstElementChild;
      if (glyph && !/[a-z]/i.test(glyph.textContent || '')) glyph.style.display = 'none';
      b.insertBefore(dot, b.firstChild);
      if (!/inline-flex|display: flex/.test(b.getAttribute('style') || '')) {
        b.style.display = 'inline-flex'; b.style.alignItems = 'center';
      }
    });
  }

  /* Asked for: the Your Product panel starts with a blank piece — no store
     photo, just the "type here" box — since the visitor is bringing their own
     item. The store photo is set aside while Your Product is open and comes
     back when Our Product is opened again. */
  var parked = null, parkedFor = null;
  function blankForYourProduct(d) {
    var L = logicOf(d);
    if (!L || L.state.step !== 'Design') return;
    var tool = L.state.tool;
    if (tool === 'product') {
      /* the store photo is set aside; the visitor's own upload stays */
      var photos = L.state.els.filter(function (e) { return e.kind === 'product' && e.source !== 'yours'; });
      if (photos.length && !L.__acpParking) {
        L.__acpParking = true;
        parked = photos; parkedFor = L;
        setTimeout(function () {
          L.setState(function (st) {
            return { els: st.els.filter(function (e) { return !(e.kind === 'product' && e.source !== 'yours'); }),
              sel: st.sel.filter(function (id) { return !photos.some(function (p) { return p.id === id; }); }) };
          }, function () { L.__acpParking = false; });
        }, 0);
      }
    } else if (parked && parkedFor === L && !L.__acpParking) {
      /* back on any other panel: the store photo returns only if the visitor
         has no piece of their own on it */
      var add = parked; parked = null;
      if (!L.state.els.some(function (e) { return e.kind === 'product'; })) {
        L.__acpParking = true;
        setTimeout(function () {
          L.setState(function (st) { return { els: add.concat(st.els) }; }, function () { L.__acpParking = false; });
        }, 0);
      }
    }
  }

  /* Asked for: each picture in the upload tray belongs to a side — the 1st is
     the Front, the 2nd is the Back — so placing one puts it on that side, opens
     that side, and that side's thumbnail is the one that changes. A 3rd or
     later picture goes on the side that is open. The tool places every upload
     as the front; it is redirected here. */
  function hookYourPlace(d) {
    var L = logicOf(d);
    if (!L || L.__acpYourPlace) return;
    L.__acpYourPlace = true;
    var orig = L.placeImage.bind(L);
    L.__acpBasePlace = orig;
    L.placeImage = function (item) {
      if (ws !== 'yours' && L.state.tool !== 'product') return orig(item);
      /* tray picture 1 is side 1, picture 2 is side 2, and so on — each
         uploaded piece is its own side */
      /* only product uploads count; toolbar files live in their own tray */
      if (item && item.acpOrigin === 'file') return placeFile(d, L, item);
      var tray = (L.state.uploads || []).filter(function (u) { return !(u && u.acpOrigin === 'file'); });
      var at = tray.indexOf(item);
      if (at < 0) at = tray.map(function (u) { return u && u.src; }).indexOf(item && item.src);
      if (at < 0) return;
      var side = sideIdAt(at);
      /* placed here rather than through the tool: the tool's placement
         replaces every product on the piece, front and back alike, and
         switches the panel; this keeps the other side's picture and text */
      try { L.snap(); } catch (e) {}
      var id = L.state.nextId;
      L.loadImg(item.src).then(function (im) { return im.width / im.height; }, function () { return item.aspect || 1; }).then(function (aspect) {
        L.setState(function (st) {
          var els = st.els.filter(function (e) { return !(e.kind === 'product' && (e.side || 'front') === side); });
          els.unshift({ id: id, side: side, type: 'image', kind: 'product', source: 'yours',
            src: item.src, origSrc: item.src, aspect: aspect, left: 50, top: 50, w: 100, bgRemoved: false });
          return { els: els, nextId: Math.max(st.nextId, id + 1), sel: [], side: side, editingId: null };
        });
      });
    };
  }

  /* Asked for: in Your Product there are as many side thumbnails as pictures
     uploaded — one per piece — not a fixed Front and Back. The tool draws two;
     the rest are added to its list here, and the thumbnail column, placing,
     photos and the design summary all follow the side index. */
  function hookSides(d) {
    var L = logicOf(d);
    if (!L || L.__acpSides) return;
    L.__acpSides = true;
    var origRV = L.renderVals.bind(L);
    L.renderVals = function () {
      var v = origRV();
      if (ws !== 'yours' || !v || !Array.isArray(v.sides)) return v;
      var n = Math.max(2, yourTray(L).length);
      var acc = v.sides.map(function (x) { return x.border; }).filter(function (c) { return c && c !== '#e5e7eb'; })[0];
      if (acc) L.__acpAccent = acc;
      acc = L.__acpAccent || '#1e2a8a';
      var cur = L.state.side || 'front';
      var sides = v.sides.slice(0, 2);
      for (var i = 2; i < n; i++) {
        (function (id) {
          var on = cur === id;
          var list = (L.state.els || []).filter(function (e) { return (e.side || 'front') === id && e.kind !== 'product'; });
          var t = list.filter(function (e) { return e.type !== 'image'; }).map(function (e) { return e.text; }).join(' ');
          sides.push({ label: String(sideIndex(id) + 1), preview: t || (list.length ? 'artwork' : 'empty'),
            border: on ? acc : '#e5e7eb', thumbBg: on ? '#f3f6ff' : '#f7f7f6', thumbFg: '#111827',
            onPick: function () { L.setState({ side: id, sel: [], editingId: null }); } });
        })(sideIdAt(i));
      }
      v.sides = sides;
      /* a piece taken out of the tray: its side goes with it */
      if (sideIndex(cur) >= n && !L.__acpSideFix) {
        L.__acpSideFix = true;
        setTimeout(function () {
          try { L.setState(function (st) { return { side: 'front', sel: [], editingId: null, els: st.els.filter(function (e) { return sideIndex(e.side || 'front') < n; }) }; }); } catch (e) {}
          L.__acpSideFix = false;
        }, 0);
      }
      return v;
    };
  }

  /* Asked for: Our Product and Your Product are separate pieces. Each keeps its
     own design (photo, text, uploads, sides, engrave choice); opening the other
     panel swaps the whole design over and back. Your Product starts blank
     with a "type here" box. */
  var ws = 'ours', store = { ours: null, yours: null };
  /* the shop can ask for a workspace before the tool is open ("Bring us your
     own piece" → Your Product); it is applied once the panel is on screen */
  var wantWs = null, ownOnly = null;
  function applyWantWs(d) {
    if (!wantWs) return;
    var L = logicOf(d);
    if (!L) return;
    /* the tool stays loaded between visits for speed, so a fresh open from
       the site can land on the last visit's Review / "Added to cart" screen
       (shop a product, check out, then "Bring us your own piece" looked
       stuck on the product). Every open from the site starts on Design with
       the cart state cleared; the design itself is kept per workspace. */
    if (L.state.step !== 'Design' || L.state.cart) {
      if (!L.__acpRewinding) {
        L.__acpRewinding = true;
        setTimeout(function () {
          try { L.setState({ step: 'Design', cart: null, sel: [], editingId: null, quoteSent: false }, function () { L.__acpRewinding = false; }); }
          catch (e) { L.__acpRewinding = false; }
        }, 0);
      }
      return;
    }
    var isYours = wantWs === 'yours';
    var btn = [].filter.call(d.querySelectorAll('button'), function (b) {
      return (isYours ? /Your Product$/ : /Our Product$/).test((b.textContent || '').replace(/\s+/g, ' ').trim());
    })[0];
    if (!btn) return;
    wantWs = null;
    ownOnly = isYours;
    if (ws !== (isYours ? 'yours' : 'ours')) btn.click();
    else if (isYours && L.state.tool !== 'product') { try { L.setState({ tool: 'product' }); } catch (e) {} }
  }
  /* Asked for: the way in decides the tabs — "Bring us your own piece" has no
     Our Product tab, and coming from the shop (grid or a product) has no Your
     Product tab; each visit is one path */
  function hideOurProduct(d) {
    var btns = [].filter.call(d.querySelectorAll('button'), function (b) {
      return /(Our|Your) Product$/.test((b.textContent || '').replace(/\s+/g, ' ').trim());
    });
    btns.forEach(function (btn) {
      var isOurs = /Our Product$/.test((btn.textContent || '').trim());
      var hide = ownOnly === null ? false : (ownOnly ? isOurs : !isOurs);
      if (hide && btn.style.display !== 'none') { btn.style.display = 'none'; btn.setAttribute('data-acp-removed', 'entry'); }
      else if (!hide && btn.getAttribute('data-acp-removed') === 'entry') { btn.style.display = ''; btn.removeAttribute('data-acp-removed'); }
    });
  }
  /* Asked for: Our Product and Your Product stand apart from Text and Icons —
     they decide whose product is being made. The pair gets a soft tint and a
     rule under it; the active tab keeps its own highlight. */
  function markWorkspaceButtons(d) {
    var btns = [].filter.call(d.querySelectorAll('button[style*="flex-direction: column"]'), function (b) {
      return /(Our|Your) Product$/.test((b.textContent || '').replace(/\s+/g, ' ').trim());
    });
    btns.forEach(function (b) {
      var glyph = b.firstElementChild;
      var isYours = /Your Product$/.test((b.textContent || '').trim());
      if (glyph && glyph.getAttribute('data-acp-logo') !== (isYours ? 'yours' : 'ours')) {
        glyph.setAttribute('data-acp-logo', isYours ? 'yours' : 'ours');
        glyph.style.display = 'flex';
        glyph.innerHTML = isYours
          /* upload tray: arrow rising out of a tray */
          ? '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 15V4"/><path d="M7.5 8.5 12 4l4.5 4.5"/><path d="M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3"/></svg>'
          /* product box with a hanging tag */
          : '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 8.5 12 4l8.5 4.5v8L12 21l-8.5-4.5z"/><path d="M3.5 8.5 12 13l8.5-4.5"/><path d="M12 13v8"/><path d="M7.5 6.4 16.5 11"/></svg>';
      }
      var active = b.style.background && b.style.background !== 'transparent';
      if (!active) {
        b.style.background = 'rgb(246, 247, 249)';
      }
      b.style.border = '1px solid rgb(226, 229, 234)';
      b.style.fontWeight = '600';
      if (/Your Product$/.test((b.textContent || '').trim())) {
        b.style.marginBottom = '10px';
        b.style.boxShadow = '0 11px 0 -10px rgb(209, 213, 219)';
      }
    });
  }
  function workspaces(d) {
    markWorkspaceButtons(d);
    var L = logicOf(d);
    if (!L || L.state.step !== 'Design' || L.__acpSwapping) return;
    var t = L.state.tool;
    var want = t === 'product' ? 'yours' : (t === 'ourproduct' ? 'ours' : ws);
    if (want === ws) return;
    store[ws] = { els: L.state.els, side: L.state.side || 'front', mode: mode, face: face };
    ws = want;
    var s = store[ws];
    if (!s) {
      var tmpl = L.state.els.filter(function (e) { return e.type !== 'image'; })[0];
      var box = tmpl ? Object.assign({}, tmpl, { id: L.state.nextId, side: 'front', text: 'type here', left: 50, top: 50 }) : null;
      s = { els: box ? [box] : [], side: 'front', mode: 'front', face: 0 };
    }
    mode = s.mode; face = s.face;
    L.__acpSwapping = true;
    setTimeout(function () {
      var maxId = s.els.reduce(function (m, e) { return Math.max(m, e.id || 0); }, 0);
      L.setState({ els: s.els, sel: [], editingId: null, side: s.side, nextId: Math.max(L.state.nextId, maxId + 1) },
        function () { L.__acpSwapping = false; });
    }, 0);
  }

  function apply(d) {
    if (!d || !d.body || applying) return;
    /* watchdog: a change that makes the page change again would spin apply
       forever; after 40 runs in a second the observer is switched off */
    var now = Date.now();
    applyTimes.push(now);
    while (applyTimes.length && now - applyTimes[0] > 1000) applyTimes.shift();
    if (applyTimes.length > 40) {
      if (d.__acpObs) { d.__acpObs.disconnect(); d.__acpObs = null; }
      d.__acpSpin = (d.__acpSpin || 0) + 1;
      try { console.error('ArcherCustomizerTweaks: apply loop stopped'); } catch (e) {}
      return;
    }
    applying = true;
    try { applyInner(d); } finally { applying = false; }
  }
  function applyInner(d) {
    try { hideProductSize(d); stepNumbers(d); } catch (e) {}
    try { hideRulers(d); } catch (e) {}
    try { fitBoxes(d); hugEditors(d); } catch (e) {}
    try { hideButtons(d); } catch (e) {}
    try { hideProducts(d); } catch (e) {}
    try { relabelUpload(d); } catch (e) {}
    try { fastBg(d); } catch (e) {}
    try { unifyBars(d); } catch (e) {}
    try { addTextButton(d); uploadButton(d); splitTrays(d); colourPicker(d); hookColour(d); } catch (e) {}
    try { arrangeBar(d); paintMirrors(d); applySafe(d); bgProgress(d); hideTextAlign(d); reviewProductLine(d); reviewColourNote(d); quoteToDownload(d); cartLine(d); noMockCheckout(d); } catch (e) {}
    try { numberSides(d); sideThumbs(d); markFaces(d); liveThumb(d); sideChooser(d); reviewTiles(d); } catch (e) {}
    try { var L0 = logicOf(d); applyWantWs(d); hideOurProduct(d); workspaces(d); if (L0 && ws === 'ours' && !wantWs) autoPick(d, L0); blankForYourProduct(d); hookYourPlace(d); hookSides(d); } catch (e) {}
    try { wireGroups(d); groupButtons(d); } catch (e) {}
  }

  /* Re-apply after the tool renders. The bundle replaces the whole body while
     it unpacks, which kills an observer attached to the old one — so the body
     actually being watched is remembered and re-attached when it changes. */
  function watch(d) {
    if (!d || !d.body || d.__acpBody === d.body) return;
    d.__acpBody = d.body;
    if (d.__acpObs) d.__acpObs.disconnect();
    apply(d);
    var queued = false;
    d.__acpObs = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; apply(d); }, 60);
    });
    d.__acpObs.observe(d.body, { childList: true, subtree: true });
    /* one caller is enough: keep checking for a swapped-in body for a while */
    if (!d.__acpPoll) {
      d.__acpPoll = setInterval(function () { watch(d); }, 700);
      setTimeout(function () { clearInterval(d.__acpPoll); d.__acpPoll = 0; }, 60000);
    }
  }

  window.ArcherCustomizerTweaks = {
    workspace: function (which) { wantWs = which === 'yours' ? 'yours' : 'ours'; }, apply: apply, watch: watch, solo: solo };
})();
